import React, { createContext, useContext, useState, useEffect } from 'react';

// Language translations
const translations = {
  en: {
    // Header
    submit: 'Submit',
    vote: 'Vote',
    shop: 'SHOP',
    dropZone: 'Drop Zones',
    streamers: 'Start My Drop Zone',
    logout: 'Logout',
    language: 'Language',
    searchStreamers: 'Search streamers...',
    suggestions: 'Suggestions',
    moreStreamers: 'More Streamers',
    
    // Gallery
    gallery: 'Gallery',
    designGallery: 'Design Gallery',
    designs: 'designs',
    sortBy: 'Sort by',
    votes: 'Votes',
    newest: 'Newest',
    oldest: 'Oldest',
    mostVoted: 'Most voted',
    filterByStreamer: 'Filter by streamer',
    allStreamers: 'All streamers',
    clearFilters: 'Clear Filters',
    reset: 'Reset',
    removeAllFilters: 'Remove all filters',
    activeFilters: 'Active Filters',
    streamer: 'Streamer',
    sortedByVotes: 'Sorted by votes',
    sortedByNewest: 'Sorted by newest',
    mostVotesFirst: 'Most votes first',
    newestFirst: 'Newest first',
    leastVotesFirst: 'Least votes first',
    oldestFirst: 'Oldest first',
    designDisplayed: 'design displayed',
    designsDisplayed: 'designs displayed',
    noDesigns: 'No designs found',
    noDesignsForCriteria: 'No designs found for these criteria.',
    loadMore: 'Load more',
    voting: 'Voting...',
    voteForYourPreferredCreations: 'Vote for your preferred creations',
    filtersAndSort: 'Filters and sort',
    customizeDesignDisplay: 'Customize the design display',
    youLikedThisDesign: 'You liked this design',
    youLiked: 'You liked',
    voteForThisDesign: 'Vote for this design',
    voteInProgress: 'Vote in progress...',
    sending: 'Sending...',
    previous: 'Previous',
    next: 'Next',
    prev: 'Prev.',
    nextShort: 'Next',
    show: 'Show',
    order: 'Order',
    of: 'of',
    total: 'total',
    pageOf: 'Page {current} of {total} ({count} design{plural} total)',
    
    // Submit
    submitDesign: 'Submit Design',
    submitADesign: 'Submit a design',
    shareCreationEarnBenefits: 'Share your original creation and receive 10% of the profits if it is selected.',
    username: 'Username',
    usernamePlaceholder: 'Username',
    personalInfo: 'Personal Information',
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'Email',
    firstNamePlaceholder: 'Your first name',
    lastNamePlaceholder: 'Your last name',
    emailPlaceholder: 'your@email.com',
    designDetails: 'Design Details',
    designTitle: 'Design Title',
    description: 'Description',
    selectStreamer: 'Select Streamer',
    chooseStreamer: 'Choose a streamer',
    filesUpload: 'Files Upload',
    dragAndDrop: 'Drag and drop your files here or click to browse',
    supportedFormats: 'Supported formats: PNG, JPG, JPEG, GIF, WEBP (Max 10MB)',
    submitting: 'Submitting...',
    success: 'Success! Your design has been submitted.',
    thankYouSubmission: 'Thank you for your submission!',
    designSubmittedSuccess: 'Your design has been sent successfully. We will review it and contact you if your creation is selected.',
    howItWorks: 'How it works?',
    makeProductEarnCommissions: 'Turn your design into a real product and earn commissions on each sale.',
    pleaseSelectStreamer: 'Please select a streamer',
    
    // Application
    application: 'Streamer Application',
    completeProfile: 'Complete your profile',
    detectedLocation: 'Detected location',
    selectLocation: 'Select your location',
    searchCountry: 'Search for a country...',
    noCountryFound: 'No country found',
    vision: 'Your Vision',
    visionPlaceholder: 'Describe your content creation vision and goals...',
    presentation: 'Your Presentation',
    presentationPlaceholder: 'Tell us about yourself, your content style, and what makes you unique...',
    youtubeLinks: 'YouTube Links',
    youtubePlaceholder: 'Paste your YouTube channel or video URLs here...',
    addAnotherLink: 'Add another link',
    socialMedia: 'Social Media',
    socialMediaPlaceholder: 'Your main social media handles or links...',
    followers: 'Followers Count',
    followersPlaceholder: 'Approximate number of followers across platforms...',
    referralCode: 'Referral Code',
    referralPlaceholder: 'If you have a referral code, enter it here...',
    streamerName: 'Streamer Name',
    streamerPlaceholder: 'Your desired streamer/creator name...',
    url: 'URL',
    urlPlaceholder: 'Your website or profile URL...',
    submitApplication: 'Submit Application',
    
    // Profile Type
    whatTypeCommunity: 'What type of community do you represent?',
    profileStreamer: 'Streamer',
    profileInfluencer: 'Influencer',
    profileDiscord: 'Discord',
    profileWebsite: 'Website',
    discordLink: 'Discord Link',
    discordLinkPlaceholder: 'https://discord.gg/...',
    memberCounter: 'Member counter',
    memberCounterPlaceholder: 'Enter your number of members',
    numberOfMembers: 'Number of members',
    enterMemberCount: 'Enter your number of members',
    monthlyTraffic: 'Monthly traffic',
    enterMonthlyTraffic: 'Enter your monthly traffic',
    submittingApplication: 'Submitting Application...',
    dropZoneCreatedSuccess: 'Drop zone created! Check your spam folder for your admin credentials.',
    dropZoneCreated: 'Drop zone created!',
    checkSpamFolder: 'Check your spam folder for your admin credentials.',
    
    // Form Fields
    emailAddress: 'Email address',
    enterEmailAddress: 'Enter your email address',
    emailAutoFilled: '✓ Email automatically filled from your account',
    mainSocialNetwork: 'Main social network (@username)',
    socialPlaceholder: 'ex: @username on Instagram, TikTok, etc.',
    subscriberCount: 'Number of subscribers',
    enterSubscriberCount: 'Enter your number of subscribers',
    referralCodeOptional: 'Referral code (optional)',
    optionalReferralCode: 'Optional referral code',
    
    // Home
    welcome: 'Welcome',
    featuredDesigns: 'Featured Designs',
    topVoters: 'Top Voters',
    topCreators: 'Top Creators',
    voteNow: 'Vote Now',
    
    // Common
    loading: 'Loading...',
    loadingDesigns: 'Loading designs...',
    retry: 'Retry',
    error: 'Error',
    close: 'Close',
    cancel: 'Cancel',
    save: 'Save',
    edit: 'Edit',
    delete: 'Delete',
    confirm: 'Confirm',
    yes: 'Yes',
    no: 'No',
    back: 'Back',
    search: 'Search',
    filter: 'Filter',
    sort: 'Sort',
    
    // Authentication & Profile
    loginToCustomize: 'Log in to customize your page before your community starts creating designs that look like you!',
    loginRequired: 'Login Required',
    mustBeLoggedIn: 'You must be logged in to access this page',
    byLoggingIn: 'By logging in, you accept our terms of use',
    connection: 'Connection',
    signIn: 'Sign in',
    signOut: 'Sign out',
    nextDrop: 'Next drop',
    days: 'days',
    selectLanguage: 'Select language',
    
    // Sidebar Navigation
    general: 'GENERAL',
    dashboard: 'Dashboard',
    website: 'WEBSITE',
    selectedWebsite: 'Selected Website',
    selectWebsite: 'Select Website',
    chooseWebsite: 'Choose a website...',
    websiteDomain: 'Website Domain',
    loadingWebsites: 'Loading websites...',
    noWebsitesFound: 'No websites found',
    shopify: 'SHOPIFY',
    orders: 'Orders',
    payment: 'Payment',
    paymentFromOrders: 'Payments from orders',
    paymentListDescription: 'Payment list from order transactions. Create order will use Shopify Payments when integrated.',
    paymentStatus: 'Status',
    paymentMethod: 'Payment method',
    shopifyPayments: 'Shopify Payments',
    filterPayments: 'Filter payments',
    loadingPayments: 'Loading payments...',
    noPaymentsYet: 'No payments yet',
    noPaymentsDescription: 'Payments will appear here when orders are created.',
    noMatchingPayments: 'No matching payments. Try changing the search.',
    orderNumber: 'Order',
    date: 'Date',
    customer: 'Customer',
    amount: 'Amount',
    products: 'Products',
    customers: 'Customers',
    analytics: 'Analytics',
    marketing: 'Marketing',
    discounts: 'Discounts',
    apps: 'Apps',
    onlineStore: 'Online Store',
    settings: 'Settings',
    backToDashboard: 'Back to dashboard',
    
    // AdminDashboard
    searchPlaceholder: 'Search...',
    currentChallenge: 'Current Challenge',
    visualValidation: 'Visual Validation',
    statistics: 'Statistics',
    archives: 'Archives',
    archived: 'Archived',
    archive: 'Archive',
    restore: 'Restore',
    uploadsSelected: 'upload(s) selected',
    noUploadsFound: 'No uploads found',
    clearFilter: 'Clear filter',
    archivedDesignsFound: 'archived design(s) found',
    currentChallenges: 'Current Challenges',
    noChallengeSelected: 'No challenge selected',
    editChallenge: 'Edit challenge',
    deleteChallenge: 'Delete challenge',
    loadingChallenges: 'Loading challenges...',
    noActiveChallengesFound: 'No active challenges found',
    selectChallenge: 'Select Challenge',
    challengeDetails: 'Challenge details',
    challengeName: 'Challenge name:',
    theme: 'Theme:',
    notSpecified: 'Not specified',
    expirationDate: 'Expiration date:',
    daysRemaining: 'Days remaining:',
    day: 'day',
    challengeStatus: 'Status:',
    expiringSoon: 'Expiring soon',
    inProgress: 'In progress',
    challengeDescription: 'Description:',
    loadingChallengesEllipsis: 'Loading challenges...',
    selectChallengeToSeeDetails: 'Select a challenge to see details',
    progress: 'Progress',
    endNow: 'End now',
    rewards: 'Rewards',
    firstPlace: '1st place',
    secondPlace: '2nd place',
    thirdPlace: '3rd place',
    noRewardDefined: 'No reward defined',
    
    // Challenge Creation Form
    createNewChallenge: 'Create new Challenge',
    challengeNameLabel: 'Challenge name',
    challengeNamePlaceholder: 'Ex: Ajoli vs Pasta',
    startDate: 'Start date',
    endDate: 'End date',
    thematic: 'Theme',
    challengeColor: 'Challenge color',
    challengeDescriptionLabel: 'Challenge description',
    challengeDescriptionPlaceholder: 'Describe the challenge in a few words...',
    food: 'Food',
    sport: 'Sport',
    art: 'Art',
    gaming: 'Gaming',
    music: 'Music',
    rewardPlaceholder: 'Reward',
    addReward: '+ Add a reward',
    createChallengeButton: 'Create challenge',
    editChallengeButton: 'Edit challenge',
    creating: 'Creating...',
    editing: 'Editing...',
    
    // Streamer Challenge Interface
    streamerChallengeInterface: 'Streamer Challenge Interface',
    challengeTitle: 'Challenge Ajoli vs Pasta',
    galleryManagement: 'Gallery Management',
    designByUser: 'Design #{{number}} by {{user}}',
    streamControls: 'Stream Controls',
    displayMode: 'Display mode',
    faceToFace: 'Face to face',
    timer: 'Timer',
    start: 'Start',
    actions: 'Actions',
    startStop: 'Start/Stop',
    endStream: 'End stream',
    overlayPreview: 'Overlay preview',
    startStreamButton: 'Start stream',
    
    // Visual Validation Tab
    loadingPendingDesigns: 'Loading pending designs...',
    showLabel: 'Show:',
    perPage: 'per page',
    statusLabel: 'Status:',
    pendingStatus: 'Pending',
    pendingAKS: 'Pending AKS',
    approvedStatus: 'Approved',
    rejectedStatus: 'Rejected',
    all: 'All',
    selectAll: 'Select all',
    deselectAll: 'Deselect all',
    deleteSelected: 'Delete',
    design: 'design',
    totalLabel: 'total',
    pendingValidation: 'pending validation',
    selected: 'selected',
    showingResults: 'Showing',
    to: 'to',
    results: 'results',
    noDesign: 'No design',
    approve: 'Approve',
    reject: 'Reject',
    publish: 'Publish',
    published: 'Published',
    editProduct: 'Edit Product',
    
    // Available Products
    availableType: 'Available Type',
    availableTypeAll: 'Available Type (All)',
    availableFor: 'Available for',
    noRestrictions: 'No restrictions — all product types',

    // Archive
    archiveDesigns: 'Archive Designs',
    newFolder: 'New Folder',
    existingFolder: 'Existing Folder',
    archiveName: 'Archive Name',
    archiveNamePlaceholder: 'Enter folder name',
    archiveDescPlaceholder: 'Enter description',
    selectFolder: 'Select Folder',
    deleteFolder: 'Delete Folder',
    deleteFolderConfirm: 'Are you sure you want to delete',
    emptyFolder: 'This folder is empty',
    noArchiveFolders: 'No archive folders yet',
    archiveFolderHint: 'Archive designs from the uploads view to create folders',

    // Final AdminDashboard translations
    selectedProducts: 'Selected products:',
    displayingResults: 'Showing {start} to {end} of {total} design{plural}',
    price: 'Price:',
    updatedOn: 'Updated on:',
    
    // UserList
    userManagement: 'User Management',
    searchByNameEmail: 'Search by name or email...',
    displayedUsers: 'Displayed Users',
    totalOnPlatform: 'Total on platform',
    filteredResults: 'Filtered results',
    adminsCount: 'Admins',
    inResults: 'In results',
    usersCount: 'Users',
    roleLabel: 'Role:',
    userRole: 'User',
    adminRole: 'Admin',
    resetFilters: 'Reset',
    filtered: 'filtered',
    among: 'among',
    page: 'Page',
    userList: 'User List',
    userColumn: 'User',
    registrationDate: 'Registration Date',
    updating: 'Updating...',
    processing: 'Processing...',
    unblockUser: 'Unblock User',
    blockUser: 'Block User',
    loadingUsers: 'Loading users...',
    noUsersFound: 'No users found',
    usersWillAppear: 'Users will appear here once they register',
    noUsersMatchFilters: 'No users match the filters',
    tryModifyingCriteria: 'Try modifying your search criteria',
    resetFiltersButton: 'Reset filters',
    blockUserTitle: 'Block User',
    unblockUserTitle: 'Unblock User',
    actionCanBeUndone: 'This action can be undone',
    areYouSureToBlock: 'Are you sure you want to block the user:',
    areYouSureToUnblock: 'Are you sure you want to unblock the user:',
    userWillNotAccess: 'The user will no longer be able to access the platform',
    userWillAccess: 'The user will be able to access the platform again',
    block: 'Block',
    unblock: 'Unblock',
    userBlockedSuccess: 'User "{userName}" has been blocked successfully',
    userUnblockedSuccess: 'User "{userName}" has been unblocked successfully',
    errorMessage: 'Error: {message}',
    networkErrorBlock: 'Network error: Unable to block user',
    networkErrorUnblock: 'Network error: Unable to unblock user',
    networkErrorUpdateRole: 'Network error: Unable to update user role',
    
    // Settings
    settingsTitle: 'Settings',
    manageInformationPreferences: 'Manage your information and preferences',
    updateInformationTab: 'Update Information',
    changePasswordTab: 'Change Password',
    updateInformationTitle: 'Update Information',
    manageProfileSocialMedia: 'Manage your profile information and social media links',
    addYoutubeLink: 'Add YouTube Link',
    youtubeUrlPlaceholder: 'https://www.youtube.com/watch?v=...',
    aboutPlaceholder: 'Tell us about yourself and your content...',
    messageSection: 'Message',
    messagePlaceholder: 'Your personalized message...',
    updateInformationButton: 'Update Information',
    changePasswordTitle: 'Change Password',
    updatePasswordSecurity: 'Update your password to keep your account secure',
    currentPassword: 'Current Password',
    currentPasswordPlaceholder: 'Enter your current password',
    newPassword: 'New Password',
    newPasswordPlaceholder: 'Enter your new password',
    confirmNewPassword: 'Confirm New Password',
    confirmPasswordPlaceholder: 'Confirm your new password',
    passwordStrength: 'Password Strength',
    passwordRequirements: 'Password must contain at least 8 characters, uppercase, lowercase, number, and special character',
    passwordsMatch: 'Passwords match',
    passwordsDoNotMatch: 'Passwords do not match',
    updatePasswordButton: 'Update Password',
    informationUpdatedSuccess: 'Information updated successfully!',
    failedUpdateInformation: 'Failed to update information',
    errorUpdatingInformation: 'Error updating information. Please try again.',
    enterCurrentPassword: 'Please enter your current password',
    enterNewPassword: 'Please enter a new password',
    passwordTooShort: 'Password must be at least 8 characters long',
    passwordRequirementsNotMet: 'Password must contain uppercase, lowercase, number, and special character',
    passwordsDoNotMatchError: 'Passwords do not match',
    passwordUpdatedSuccess: 'Password updated successfully!',
    failedUpdatePassword: 'Failed to update password',
    errorUpdatingPassword: 'Error updating password. Please try again.',
    
    // Settings - Additional Fields
    name: 'Name',
    namePlaceholder: 'Your full name',
    country: 'Country',
    searchCountryPlaceholder: 'Search for a country...',
    socialMediaLabel: 'Social Media',
    socialMediaTypePlaceholder: '@username',
    subscriberCountLabel: 'Subscriber Count',
    subscriberCountPlaceholder: '1000 subscribers, 5K, 10.2M, etc.',
    servicesSection: 'Services',
    serviceUrlPlaceholder: 'https://example.com',
    serviceCaptionPlaceholder: 'e.g., Best Game Deals',
    uploadNewImage: 'Upload New Image',
    changePhoto: 'Profile/Logo',
    profilePhoto: 'Profile',
    logoPhoto: 'Logo',
    
    // Media Gallery
    mediaGallery: 'Media Gallery',
    manageImageCollection: 'Manage your professional image collection',
    images: 'Images',
    dropImagesHere: 'Drop images here',
    orClickToSelectMultiple: 'or click to select (multiple)',
    browseFiles: 'Browse Files',
    yourImages: 'Your Images',
    profile: 'profile',
    image: 'image',
    primary: 'primary',
    
    // Logo Section
    uploadLogo: 'Upload Logo',
    uploadLogoDescription: 'Upload images for your logo. The first logo will be used as the main logo.',
    dropLogoHere: 'Drop logo here',
    orClickToSelect: 'or click to select',
    yourLogos: 'Your Logos',
    mainLogo: 'main logo',
    logoNumber: 'logo #',
    
    // Language Button
    addLanguage: 'Language',
    
    // Tips Section
    tips: 'Tips:',
    tipSelectText: 'Select text and right-click to show formatting options',
    tipChooseFormatting: 'Choose from Bold, Italic, Underline, and Colors',
    tipCopyFormatted: 'Copy formatted text from other sources to preserve formatting',
    
    // Services Section
    noServicesAdded: 'No services added yet. Click "Add Service" to get started.',
    addServiceButton: 'Add Service',
    
    // Website URL
    visitOurWebsite: 'Visit our website',
    
    // AdminDashboardOwner
    overviewTab: 'Overview',
    userManagementTab: 'Streamer Management',
    analyticsTab: 'Analytics',
    applicationsTab: 'Applications',
    suggestionsTab: 'Suggestions',
    imageManagerTab: 'Image Manager',
    welcomeAdminDashboard: 'Welcome to the administrator dashboard',
    connectedAs: 'You are connected as:',
    ownerStatus: 'Owner status:',
    informationLabel: 'Information',
    selectWebsiteInSidebar: 'Select a website in the sidebar to see uploads with status 9.',
    quickActions: 'Quick Actions',
    manageUsers: 'Manage Streamers',
    viewModifyUserAccounts: 'View and modify streamer accounts',
    viewAnalytics: 'View Analytics',
    detailedStatisticsReports: 'Detailed statistics and reports',
    systemSettings: 'System Settings',
    globalConfiguration: 'Global configuration',
    userManagementTitle: 'Streamer Management',
    userManagementFeatureComingSoon: 'Manage your approved streamers and their account status.',
    inDevelopment: 'Active',
    userManagementSectionDescription: 'This section allows you to block or unblock streamers and notify them via email.',
    loadingStreamers: 'Loading streamers...',
    noStreamersFound: 'No approved streamers found.',
    streamerEmail: 'Email',
    streamerNameLabel: 'Streamer Name',
    accountStatus: 'Status',
    actionsColumn: 'Actions',
    blockStreamer: 'Block Streamer',
    unblockStreamer: 'Unblock Streamer',
    blockReason: 'Reason for blocking',
    blockReasonPlaceholder: 'Enter the reason for blocking this streamer...',
    confirmBlock: 'Confirm Block',
    cancelAction: 'Cancel',
    blocked: 'Blocked',
    activeStatus: 'Active',
    blockingStreamer: 'Blocking streamer...',
    unblockingStreamer: 'Unblocking streamer...',
    streamerBlockedSuccess: 'Streamer blocked successfully and notified via email.',
    streamerUnblockedSuccess: 'Streamer unblocked successfully and notified via email.',
    errorBlockingStreamer: 'Error blocking streamer. Please try again.',
    errorUnblockingStreamer: 'Error unblocking streamer. Please try again.',
    blockReasonRequired: 'Please provide a reason for blocking.',
    analyticsStatisticsTitle: 'Analytics and Statistics',
    analyticsFullDashboardComingSoon: 'Complete analytics dashboard coming soon.',
    suggestionsManagementTitle: 'Suggestions Management',
    streamerSuggestionsSubmittedByCommunity: 'Streamer suggestions submitted by the community',
    loadingSuggestions: 'Loading suggestions...',
    errorLoadingApplications: 'Error loading applications: {message}',
    networkErrorLoadingApplications: 'Error loading applications',
    errorLoadingSuggestions: 'Error loading suggestions: {message}',
    networkErrorLoadingSuggestions: 'Error loading suggestions',
    errorApproving: 'Error approving: {error}',
    networkErrorApproving: 'Network error during approval',
    errorRejecting: 'Error rejecting: {error}',
    networkErrorRejecting: 'Network error during rejection',
    errorLoadingUploads: 'Error loading uploads',
    networkErrorLoadingUploads: 'Network error loading uploads',
    apiError: 'API Error: {status}',
    loadingUploads: 'Loading uploads...',
    unknownError: 'Unknown error',
    uploadsFoundPending: '{count} upload(s) found pending',
    noPendingImages: 'No pending images',
    
    // Toast Messages - AdminDashboard & AdminDashboardOwner
    uploadApprovedSuccess: 'Upload approved successfully!',
    uploadRejectedSuccess: 'Upload rejected successfully!',
    uploadDeletedSuccess: 'Upload deleted successfully!',
    errorPublishStatusUpdate: 'Error updating publish status',
    productCreatedShopifySuccess: 'Product created successfully on Shopify!',
    errorCreatingProduct: 'Error creating product',
    challengeCreatedSuccess: '🎉 Challenge created successfully!',
    challengeModifiedSuccess: '🎉 Challenge modified successfully!',
    challengeDeletedSuccess: '🗑️ Challenge deleted successfully!',
    errorDeletingChallenge: 'Error deleting challenge',
    challengeEndedSuccess: '🏁 Challenge ended successfully!',
    errorEndingChallenge: 'Error ending challenge',
    errorCreatingChallenge: 'Error creating challenge',
    errorModifyingChallenge: 'Error modifying challenge',
    noDesignSelected: '❌ No design selected',
    designsDeletedSuccess: '🗑️ {count} design(s) deleted successfully!',
    designsDeletedPartial: '⚠️ {successCount} design(s) deleted, {failedCount} failure(s)',
    errorDeletingAllDesigns: '❌ Failed to delete all selected designs',
    errorDeletingDesigns: '❌ Error deleting designs',
    noWebsiteSelected: 'No website selected',
    uploadSentForReview: 'Upload sent to streamer for review!',
    applicationApprovedSuccess: 'Application approved successfully! Admin account created.',
    applicationRejectedSuccess: 'Application rejected successfully.',
    uploadsLoadedCount: 'Loaded {count} uploads for {website}',
    rejectionReasonRequired: 'Rejection reason required',
    selectRejectionReason: 'Please select a rejection reason',
    
    // Blur Image Feature
    blurImage: 'Blur Image',
    blurReasonRequired: 'Please select a blur reason',
    approveWithBlur: 'Approve with Blur',
    imageBlurredSuccess: 'Image approved with blur successfully!',
    selectBlurReason: 'Select blur reason...',
    viewImage: 'View Image',
    imageBlurred: 'This image is blurred',
    explicitContentWarning: 'This image displays explicit content. You must confirm you are over 18 to continue.',
    
    // Mockup Generation
    generateMockup: 'Generate Mockup',
    selectProductType: 'Select a product type',
    mockupPreview: 'Mockup Preview',
    generatingMockup: 'Generating mockup...',
    mockupGenerationTime: 'This may take 10-30 seconds',
    mockupError: 'Mockup generation failed',
    mockupGenerationFailed: 'Unable to generate mockup. Please try again.',
    mockupGenerationError: 'An error occurred while generating the mockup.',
    openFullSize: 'Open Full Size',
    
    // Image Manager
    manageAllImages: 'Manage all uploaded images across all websites',
    totalImages: 'Total Images',
    filterByWebsite: 'Website:',
    allWebsites: 'All Websites',
    clearFiltersButton: 'Clear Filters',
    noImagesFound: 'No images found',
    noImagesMatchCriteria: 'No images match the current filters.',
    loadingImages: 'Loading images...',
    submittedAt: 'Submitted',
    confirmDeletion: 'Confirm Deletion',
    thisActionCannotBeUndone: 'This action cannot be undone',
    imageDetails: 'Image Details',
    untitled: 'Untitled',
    areYouSureDelete: 'Are you sure you want to delete this image?',
    imageWillBeRemoved: 'This image will be permanently removed.',
    errorLoadingImages: 'Error loading images',
    errorDeletingImage: 'Error deleting image',
    
    errorLoadingChallenges: 'Error loading challenges',
    networkErrorLoadingChallenges: 'Network error loading challenges',
    noChallengesFound: 'No challenges found',
    createFirstChallenge: 'Create your first challenge to start engaging your community!',
    createChallenge: 'Create a challenge',
    refreshPage: 'refresh the page',
    ifYouThinkError: 'if you think there\'s an error',
    noChallengesWithFilters: 'No challenges found with current filters',
    or: 'Or',
    challengesList: 'Challenges List',
    searchChallengePlaceholder: 'Search for a challenge...',
    upcoming: 'Upcoming',
    finished: 'Finished',
    created: 'Created',
    allStatuses: 'All statuses',
    errorCreatingAccount: 'Error creating account',
    loginError: 'Login error',
    
    // Application.js Toast Messages
    pleaseAddProfilePhoto: 'Please add a profile photo',
    pleaseWriteVision: 'Please write your vision',
    pleaseWritePresentation: 'Please write your presentation',
    pleaseIndicateSocialMedia: 'Please indicate your main social network',
    pleaseIndicateFollowerCount: 'Please indicate your subscriber count',
    pleaseIndicateStreamerName: 'Please indicate your streamer/site name',
    streamerNameExists: 'This streamer name already exists. Please choose another one.',
    authenticationError: 'Authentication error. Please log in again.',
    invalidImageFormat: 'Please upload a valid image file (PNG, JPEG, JPG, or WebP)',
    fileTooLargeProfile: 'File is too large ({size}MB). Maximum size: 10MB.',
    fileTooLargeUpload: 'File is too large. Maximum size: 10MB.',
    fileSizeNote: '⚠️ Maximum file size: 10MB per file',
    designUploadImportant: 'IMPORTANT: Upload your design alone on a transparent background.',
    designUploadNoMockups: 'Do not submit mock-ups (designs already placed on clothing or objects).',
    sessionExpiredLogin: 'Session expired. Please log in to submit applications.',
    authenticationErrorOccurred: 'Authentication error occurred.',
    
    // Submit.js Messages
    invalidFileFormat: 'Invalid file format for preview. Please use PNG, JPG, or WebP.',
    fileTooLarge: 'Preview file is too large. Maximum 10MB.',
    
    // TopVoters page
    discoverActiveMembers: 'Discover the most active members of our community who support their preferred creations.',
    votersCount: 'voter',
    votersCountPlural: 'voters',
    updatedRealTime: 'Updated in real time',
    retryButton: 'Retry',
    noVotersYet: 'No voters yet',
    beFirstToVote: 'Be the first to vote for your favorite designs!',
    rank: 'Rank',
    totalVoters: 'Total',
    
    loginToVoteSubmit: 'Log in to vote and submit your creations',
    backToHome: 'Back to home',
    myProfile: 'My Profile',
    loggedInAs: 'Logged in as',
    loggingIn: 'Logging in...',
    
    // TopCreators page
    discoverTopCreatorsGlobal: 'Discover the most talented creators who submitted their designs.',
    discoverTopCreatorsForShop: 'Discover the most talented creators who submitted their designs for the {shopName} shop.',
    creatorsCount: 'creator',
    creatorsCountPlural: 'creators',
    topCreatorsLoadError: 'Failed to load top creators. Please try again later.',
    noCreatorsYet: 'No creators yet',
    beFirstToSubmitCreators: 'Be the first to submit your creations!',
    designsColumn: 'Designs',
    designLabel: 'design',
    designLabelPlural: 'designs',
    anonymousCreator: 'Anonymous Creator',
    profilePictureFromGoogle: 'Profile picture from Google',
    footerDesignsTotal: 'Designs',
    footerVotesTotal: 'Votes',
    
    // Loading & Messages
    loadingTopVoters: 'Loading top voters...',
    loadingTopCreators: 'Loading top creators...',
    sendingInProgress: 'Sending in progress...',
    submitMyDesign: 'Submit my design',
    anErrorOccurred: 'An error occurred:',
    submitUploadFailed: 'Upload failed. Please try again.',
    submitSessionExpired: 'Your session may have expired. Your design was not submitted. You can log in and try again, or continue without logging in but with limited submissions per day.',
    submitLimitReached: 'You have reached the submission limit for today. Please try again tomorrow.',
    submitGenericError: 'There was an error submitting your design. Please try again.',
    creationTitle: 'Creation Title',
    catchyTitlePlaceholder: 'A catchy title for your creation',
    
    // Voting & Designs
    yourTurnToVote: 'Your turn to vote!',
    discoverProposedCreations: 'Discover the proposed creations and vote for those you want to see produced.',
    
    // Pending Page
    applicationsProcessed: 'Applications are generally processed within 24-48 hours. Come back soon to see this streamer\'s profile!',
    becomeStreamer: 'Become Streamer',
    areYouThisStreamer: 'Are you this streamer? Contact our team if you have questions about your application.',
    
    // Admin & Settings
    users: 'Users',
    administration: 'Administration',
    submissions: 'Submissions',
    challenges: 'Challenges',
    
    // Home page
    giveLifeToCommunity: 'Give life to your community!',
    ultimatePlatformStreamers: 'The ultimate platform for streamers, where your community\'s ideas come to life. Generate revenue, engage your followers and offer them an exclusive experience to support you.',
    createDropZone: 'Create my Drop Zone',
    seeDropZones: '🔍 See Drop Zones',
    threeRolesMission: 'Three roles,',
    oneMission: ' one mission',
    unlockCreativity: 'Unlock creativity.',
    creator: 'Creator',
    contentCreator: 'content creator',
    earn30Percent: 'Earn <span class="text-purple-400 font-bold">30% of profits</span> on each product sold in your Drop Zone.',
    diversifyRevenue: 'Diversify your revenue while keeping control over your creations.',
    strengthenEngagement: 'Strengthen engagement of your community with <span class="text-purple-400 font-bold">exclusive events</span>, <span class="text-purple-400 font-bold">creative battles</span> and <span class="text-purple-400 font-bold">giveaways</span>.',
    hundredPercentManaged: 'Enjoy <span class="text-purple-400 font-bold">100% managed handling</span>: store, production, shipping... everything is handled for you.',
    createStrongBond: 'Create a strong bond with your community through unique and creative designs.',
    artistDesigner: 'Artist · Designer ·',
    promptKing: 'Prompt King',
    propose10Percent: 'Propose your creations and receive <span class="text-cyan-400 font-bold">10% of profits</span> on each product sold with your design.',
    getArtistBadge: 'Get an <span class="text-cyan-400 font-bold">artist badge</span> and gain visibility among streamer communities.',
    participateGiveaways: 'Participate in <span class="text-cyan-400 font-bold">exclusive giveaways</span> reserved for artists and designers.',
    expressFreelyCreativity: 'Express freely your creativity and bring your ideas to life, with or without AI.',
    proposeCreation: 'Propose my creation',
    member: 'Member',
    communityMember: 'of the community',
    supportCreators: 'Directly support your favorite creators with each purchase.',
    becomeVIP: '<span class="text-yellow-400 font-bold">Become VIP</span> and unlock <span class="text-yellow-400 font-bold">exclusive rewards</span>: unique designs, special events, privileged interactions.',
    winGoldenTicket: 'Win the <span class="text-yellow-400 font-bold">Golden Ticket</span>: each purchase gives you a chance to obtain this pass and access unique gifts (private call, signed products, etc.).',
    exclusiveDigitalContent: 'Enjoy <span class="text-yellow-400 font-bold">exclusive digital content</span>: wallpapers, ringtones and creations offered by your favorite artists.',
    discoverDropZones: 'Discover Drop Zones',
    dropZonesToDiscover: 'Drop Zones to discover',
    createDropZoneEmoji: 'Create my Drop Zone ✏️',
    suggestCreator: 'Suggest a creator ✏️',
    frequentQuestions: 'Frequently asked questions',
    howVotingWorks: 'How does the voting of creations work?',
    eachMemberCanVote: 'Each member can vote for as many creations as they want.',
    mostPopularProduced: 'The most popular ones will be produced for the next Drop.',
    whenWinnersAnnounced: 'When are the winning designs announced?',
    endOfVotingPeriod: 'At the end of each voting period, directly on the concerned Drop Zone.',
    howSubmitCreation: 'How to submit my creation?',
    submitTabUpload: 'In the Submit tab, upload your design, choose the products, accept the conditions and validate in one click.',
    howMuchEarn: 'How much do I earn if my creation is selected?',
    earn10PercentBenefits: 'You earn 10% of the profits generated by each sale of your design.',
    whichProducts: 'On which products will the designs be printed?',
    creationsProducedSupports: 'Creations can be produced on several supports: t-shirts, caps, tote bags, mugs and posters. Other supports may be added in the future.',
    whatDeadline: 'What is the deadline to submit a creation?',
    noDeadline: 'No deadline: you can submit your ideas at any time.',
    onlySpecialEvents: 'Only participations in an event or special theme will have an indicated closing date.',
    moreDropsFuture: 'Will there be other Drops in the future?',
    yesNewDrops: 'Yes! New Drops are planned continuously, with new themes and new creations',
    seeMore: 'See more',
    seeLess: 'See less',
    proposeStreamer: 'Propose a streamer',
    enterStreamerName: 'Enter the streamer name...',
    suggest: 'Suggest',
    suggestionLimitReached: 'Suggestion limit reached.',
    suggestionSuccessThanks: 'Thank you! Your suggestion "{name}" was sent successfully.',
    suggestionRateLimitWait:
      'You already made a suggestion recently. Please wait {hours}h {minutes}min before making another one.',
    suggestStreamerNameRequired: 'Streamer name is required.',
    suggestStreamerNameTooLong: 'Streamer name is too long (max 100 characters).',
    suggestStreamerNameInvalid:
      'Streamer name can only contain letters, numbers, spaces, hyphens and underscores.',
    suggestInvalidDataFormat: 'Invalid data format.',
    errorSendingSuggestion: 'Error sending suggestion.',
    errorSendingSuggestionRetry: 'Error sending suggestion. Please try again.',
    
    // Footer
    platformDescription: 'Merchandising platform where communities can submit, vote and buy unique designs.',
    quickLinks: 'Quick Links',
    home: 'Home',
    information: 'Information',
    contact: 'Contact',
    legalInformation: 'Legal Information',
    termsAndConditions: 'Terms and Conditions of Pimp My Drop',
    termsSection4Title: 'Assignment of Rights to Designs and Compensation',
    termsImportant: 'Important',
    termsSection4ImportantText: 'By uploading a design to "pimp my drop", you will be explicitly informed of and must consent to the fact that you assign all of your intellectual property rights to this design to "pimp my drop". This assignment is voluntary, final, and irrevocable from the moment the upload is completed.',
    termsSection4AllowsUs: 'This allows us to use, modify, reproduce, and commercialize the design, including for:',
    termsSection4Bullet1: 'The creation and sale of products through our Shopify store;',
    termsSection4Bullet2: 'Promotion, advertising, and community engagement on social media (Instagram, Twitter, Discord, etc.) and other "pimp my drop" marketing channels, with no limitation in duration or territory.',
    termsSection4MinorsTitle: 'Policy Regarding Minors',
    termsSection4MinorsText: 'Any natural person, including minors, is allowed to submit designs on the platform. However, in accordance with applicable laws, minor users are not eligible for the compensation or revenue-sharing program. By submitting a design, the minor user (and their legal representative) accepts that this contribution is made on a purely voluntary and unpaid basis, with no compensation other than potential visibility offered by our platform.',
    legalNotices: 'Legal Notices',
    allRightsReserved: 'All rights reserved',
    
    // Submit page specific
    termsAgreement: 'I hereby declare, under honor, that I am the original author of this design and that it does not infringe any copyright or trademark. I accept the terms of the',
    cessionContract: 'assignment agreement',
    andUnderstand: 'and understand that the 10% compensation is reserved for adult users.',
    optional: '(Optional)',
    previewFileRequired: 'Preview file is required',
    selectAtLeastOneProduct: 'Please select at least one suitable product for your design',
    fillAllRequiredFields: 'Please fill in all required fields',
    mustAcceptTerms: 'You must accept the terms of the assignment contract',
    challenge: 'Challenge',
    searchChallenge: 'Search for a challenge...',
    noChallengeFound: 'No challenge found',
    noStreamerFound: 'No streamer found',
    previewFiles: 'Preview files (PNG, WebP)',
    dropFileHere: 'Drop the file here',
    dragOr: 'Drag or',
    browse: 'Browse',
    pngJpgWebp: 'PNG, WebP (transparent background only)',
    removeFile: 'Remove file',
    onlyPngWebpAllowed: 'Only PNG and WebP formats are allowed.',
    transparentBackgroundRequired: 'Image must have a transparent background (no background). Please remove the background and try again.',
    checkingTransparency: 'Checking transparency...',
    verifyingNoBackground: 'Verifying image has no background',
    suitableProducts: 'Suitable products for this design',
    cap: 'Cap',
    
    // How it works section
    tenPercentBenefits: '10% Benefits',
    receive10Percent: 'Receive 10% of net profits on each product sold with your design.',
    dashboardTracking: 'A dashboard allows you to track your sales at each step.',
    noEarningsCap: 'No cap on earnings',
    automaticPayments: 'Automatic payments at the end of the month',
    preciseTracking: 'Precise tracking of sales and revenue',
    productVariety: 'A variety of products',
    creationsPrinted: 'Your creations can be printed on different supports:',
    tshirtsSweatshirts: 'T-shirts and sweatshirts',
    capsAccessories: 'Caps and accessories',
    mugsCups: 'Mugs and cups',
    muchMore: 'And much more!',
    viralExposure: 'Viral exposure',
    networkVisibility: 'Take advantage of our network\'s visibility to give your ideas a real spotlight.',
    millionViews: 'Over 1 million views per quarter',
    hundredsPartners: 'Hundreds of partner accounts',
    internationalDiffusion: 'International distribution on social networks',
    dropSystem: 'Drop system',
    functionByDrops: 'We operate by drops (organized launches) to create excitement and boost demand.',
    announcedPeriods: 'Announced voting and launch periods',
    trackingTools: 'Tracking tools to maximize your earnings',
    massiveCommunication: 'Massive communication around each drop',
    
    // Shop
    comingSoon: 'Coming Soon',
    shopComingSoon: 'The shop is coming soon',
    shopDiscoverProducts: 'Discover exclusive products from our streamers',
    findPerfectProduct: 'Find the perfect product',
    searchProducts: 'Search products...',
    orderNow: 'Order Now',
    outOfStock: 'Out of Stock',
    
    // Shop Create Order Modal
    shopCreateOrder: 'Create Order',
    shopFillDetailsToPlaceOrder: 'Fill in your details to place an order',
    shopProducts: 'Products',
    shopProduct: 'Product',
    shopQuantity: 'Quantity',
    shopTotal: 'Total',
    shopPayment: 'Payment',
    shopSubtotal: 'Subtotal',
    shopShippingInformation: 'Shipping Information',
    shopFirstName: 'First Name',
    shopLastName: 'Last Name',
    shopCustomerEmail: 'Customer Email',
    shopAddress: 'Address',
    shopPhone: 'Phone',
    shopPhoneRequired: 'Please enter a valid phone number (at least 6 digits)',
    shopCity: 'City',
    shopCountry: 'Country',
    shopZipCode: 'ZIP Code',
    shopGenerateMockup: 'Generate Mockup',
    shopSelectProductType: 'Select a product type',
    shopMockupPreview: 'Mockup Preview',
    shopDelete: 'Delete',
    shopEditMockup: 'Edit Mockup',
    shopCancel: 'Cancel',
    shopPaymentCompleteOrder: 'Complete your order',
    shopOrderTotal: 'Order total',
    shopPaymentDetailsMock: 'Payment details (mock - no API for now)',
    shopBogusGatewayTitle: 'Bogus Gateway (Sandbox)',
    shopBogusGatewayHint: 'Test card: 1 = success, 2 = declined, 3 = error. No real charge.',
    shopCardType: 'Card type',
    shopCardNumberRequired: 'Please enter a valid card number',
    shopCardNumber: 'Card number',
    shopNameOnCard: 'Name on card',
    shopExpiry: 'Expiry',
    shopCVV: 'CVV',
    shopBack: 'Back',
    shopPayCreateOrder: 'Pay & Create Order',
    shopProcessing: 'Processing...',
    shopOrderReceipt: 'Order Receipt',
    shopCustomer: 'Customer',
    shopShippingAddress: 'Shipping Address',
    shopGeneratingInvoice: 'Generating invoice...',
    shopSendingToEmail: 'Sending to your email',
    shopOrderDetails: 'Order Details',
    shopCustomization: 'Customization',
    shopSendingInvoiceToEmail: 'Sending invoice to your email...',
    shopInvoiceSentTo: 'Invoice sent to',
    shopPreparingToSendInvoice: 'Preparing to send invoice...',
    shopDone: 'Done',
    
    // Application Page Remaining  
    welcomeDropZone: 'Welcome to your',
    dropZoneExclamation: 'Drop Zone!',
    createYourSpace: 'Create your space, a place where ideas take shape and become reality.',
    addProfilePhotoAndVisuals: 'Add your profile photo and visuals',
    clickUploadDragDrop: 'Click to upload or drag-and-drop your profile picture and images.',
    suggestVisualsDropZone: 'Suggest visuals that could illustrate your drop zone. These files won\'t be published automatically, but they\'ll help us personalize your page.',
    selectProfileFromAdded: 'Select the profile photo you\'d like to use from the images you\'ve added. Choose a clear and representative visual (logo, portrait, or brand identity).',
    acceptedFormatsPhoto: 'Accepted formats: PNG, JPEG, JPG, WebP',
    validImageUploaded: 'Valid image ({size}MB)',
    clickHereUpload: 'Click here to upload',
    writeVision: 'Write your vision',
    explainWhatShare: 'Explain what you want to share or develop with your community.',
    highlightValues: 'Highlight your values, objectives or the atmosphere you want to create.',
    writeVisionHere: 'Write your vision here...',
    introduceYourself: 'Introduce yourself',
    talkAboutContent: 'Talk about your content, your passions or your universe.',
    fewLinesEnough: 'A few lines are enough to make people want to discover your world.',
    writeIntroHere: 'Write your introduction here...',
    showcaseContent: 'Showcase your content (optional)',
    addOneMoreVideos: 'Add one or more videos (presentation, best-of, highlights) to engage your audience from the first visit.',
    addLink: 'Add link',
    removeThisLink: 'Remove this link',
    applicationSubmittedSuccess: 'Application submitted successfully! Your page will be available soon.',
    errorDuringSubmission: 'An error occurred during submission',
    errorOccurred: 'An error occurred. Please try again.',
    
    // Final Application Form Elements
    creatorProjectName: 'Creator or project name',
    creatorNamePlaceholder: 'e.g., MyCreatorName or MyProjectName',
    nameWillIdentifyPage: 'This name will be used to identify your page',
    publicationSubjectVerification: 'Publication subject to verification',
    whenReadyClickPublish: 'When everything is ready, click on',
    publishMyDropZone: 'Publish my Drop Zone',
    pageVerifiedByTeam: 'Each page is verified by our team before going online to guarantee a quality experience. The publication is therefore',
    notInstantaneous: 'not instantaneous',
    publishingInProgress: 'Publishing...',
    noStressModifyLater: 'No stress, you can modify everything later.',
    
    // Streamers Page
    voteForThem: 'Vote for them!',
    discoverCreationsAndVote: 'Discover the proposed creations and vote for the ones you want to see produced.',
    categories: 'Categories',
    tShirts: 'T-shirts',
    allProducts: 'All Products',
    mugs: 'Mugs',
    accessories: 'Accessories',
    caps: 'Caps',
    areYouCreative: 'Are You Creative?',
    participateInCommunity: 'Participate in the community',
    proposeYourDesigns: 'Propose your designs',
    earnCommissions: 'Earn commissions',
    accessDropZone: 'Access Drop Zone',
    hallOfFame: 'Hall of Fame',
    seeLeaderboard: 'See Leaderboard',
    aboutSection: 'About',
    youtubeShorts: 'YouTube SHORTS',
    seeAllVideos: 'See all videos',
    areYouCreator: 'Are you a',
    participateInCommunityAndEarn: 'Participate in the community and transform your ideas into products.',
    welcomeToMyPage: 'Welcome to my page!',
    
    // Buttons and Actions (New keys only)
    submitCreation: 'Submit a creation',
    voteForDesigns: 'Vote for designs',
    seeAllCreations: 'See all creations',
    seeAllArchive: 'See all archive',
    submitMyCreation: 'Submit my creation',
    seeMoreVideos: 'See more videos',
    
    // Video section
    video: 'Video',
    loadingVideos: 'Loading videos...',
    clickToWatch: 'Click to watch',
    
    // These FAQ keys already exist elsewhere in the file
    
    // Creative Process
    submitYourCreation: 'Submit your creation',
    proposeOriginalDesign: 'Propose an original design: illustration, slogan, artwork... let your imagination speak.',
    signContract: 'Sign the contract',
    ifDesignSelected: 'If your design is selected, 10% of sales return to you automatically.',
    
    // Creator Features
    communityCreativity: 'Community creativity',
    passiveRevenue: 'Passive revenue',
    increasedVisibility: 'Increased visibility',
    
    // Loading States
    loadingProfile: 'Loading profile...',
    
    // Creative Process Step 3
    crossFingers: 'Cross your fingers',
    mostVotedSelected: 'Creations that get the most votes will be selected for production.',
    top5DesignsUsed: 'If your design is among the top 5 most voted, it will be used on the first drop items.',
    
    from: 'From',
    for: 'for',
    
    // UserDashboard
    myDashboard: 'My Dashboard',
    myUploads: 'My uploads',
    myVotes: 'My votes',
    navigation: 'NAVIGATION',
    myDesigns: 'My Designs',
    designsUploaded: 'Designs uploaded',
    designsVoted: 'Designs voted',
    averageVotes: 'Average votes',
    newDesign: 'New Design',
    by: 'by',
    votesTotal: 'votes total',
    approved: 'approved',
    pending: 'pending',
    rejected: 'rejected',
    deleted: 'deleted',
    review: 'review',
    unknown: 'unknown',
    noUploadYet: 'No upload yet',
    deleteDesign: 'Delete design',
    areYouSure: 'Are you sure you want to delete',
    thisActionIrreversible: 'This action is irreversible.',
    deleting: 'Deleting...',
    successfullyDeleted: 'Successfully deleted.',
    failedToDelete: 'Failed to delete',
    reasonForRejection: 'Reason for rejection:',
    myChallenges: 'My Challenges',
    challengesCreated: 'Challenges created',
    noChallenge: 'No challenge created',
    createdOn: 'Created on',
    expiresOn: 'Expires on',
    active: 'Active',
    ended: 'Ended',
    participants: 'Participants:',
    noVoteYet: 'No vote yet',
    discoverDesigns: 'Discover designs',
    voted: 'Voted',
    status: 'Status:',
    errorDeletingTryAgain: 'Error deleting upload. Please try again.'
  },
  fr: {
    // Header
    submit: 'Soumettre',
    vote: 'Voter',
    shop: 'SHOP',
    dropZone: 'Drop Zones',
    streamers: 'Lancer Ma Drop Zone',
    logout: 'Déconnexion',
    language: 'Langue',
    searchStreamers: 'Rechercher des streamers...',
    suggestions: 'Suggestions',
    moreStreamers: 'Plus de Streamers',
    
    // Gallery
    gallery: 'Galerie',
    designGallery: 'Galerie',
    designs: 'designs',
    sortBy: 'Trier par',
    votes: 'Votes',
    newest: 'Plus récent',
    oldest: 'Plus ancien',
    mostVoted: 'Plus voté',
    filterByStreamer: 'Filtrer par streamer',
    allStreamers: 'Tous les streamers',
    clearFilters: 'Effacer les filtres',
    reset: 'Réinitialiser',
    removeAllFilters: 'Supprimer tous les filtres',
    activeFilters: 'Filtres actifs',
    streamer: 'Streamer',
    sortedByVotes: 'Triés par votes',
    sortedByNewest: 'Triés par nouveautés',
    mostVotesFirst: 'Plus de votes en premier',
    newestFirst: 'Plus récents en premier',
    leastVotesFirst: 'Moins de votes en premier',
    oldestFirst: 'Plus anciens en premier',
    designDisplayed: 'design affiché',
    designsDisplayed: 'designs affichés',
    noDesigns: 'Aucun design trouvé',
    noDesignsForCriteria: 'Aucun design trouvé pour ces critères.',
    loadMore: 'Charger plus',
    voting: 'Vote en cours...',
    voteForYourPreferredCreations: 'Votez pour vos créations préférées',
    filtersAndSort: 'Filtres et tri',
    customizeDesignDisplay: 'Personnalisez l\'affichage des designs',
    youLikedThisDesign: 'Vous avez aimé ce design',
    youLiked: 'Vous avez aimé',
    voteForThisDesign: 'Voter pour ce design',
    voteInProgress: 'Vote en cours...',
    sending: 'Envoi...',
    previous: 'Précédent',
    next: 'Suivant',
    prev: 'Préc.',
    nextShort: 'Suiv.',
    show: 'Afficher',
    order: 'Ordre',
    of: 'sur',
    total: 'au total',
    pageOf: 'Page {current} sur {total} ({count} design{plural} au total)',
    
    // Submit
    submitDesign: 'Soumettre un Design',
    submitADesign: 'Soumettre un design',
    shareCreationEarnBenefits: 'Partage ta création originale et reçois 10 % des bénéfices si elle est sélectionnée.',
    username: 'Nom d\'utilisateur',
    usernamePlaceholder: 'Nom d\'utilisateur',
    personalInfo: 'Informations Personnelles',
    firstName: 'Prénom',
    lastName: 'Nom',
    email: 'Email',
    firstNamePlaceholder: 'Votre prénom',
    lastNamePlaceholder: 'Votre nom',
    emailPlaceholder: 'votre@email.com',
    designDetails: 'Détails du Design',
    designTitle: 'Titre du Design',
    description: 'Description',
    selectStreamer: 'Sélectionner un Streamer',
    chooseStreamer: 'Choisir un streamer',
    filesUpload: 'Téléchargement de Fichiers',
    dragAndDrop: 'Glissez-déposez vos fichiers ici ou cliquez pour parcourir',
    supportedFormats: 'Formats supportés: PNG, JPG, JPEG, GIF, WEBP (Max 10MB)',
    submitting: 'Soumission...',
    success: 'Succès! Votre design a été soumis.',
    thankYouSubmission: 'Merci pour votre soumission!',
    designSubmittedSuccess: 'Votre design a été envoyé avec succès. Nous l\'examinerons et vous contacterons si votre création est sélectionnée.',
    howItWorks: 'Comment ça marche ?',
    makeProductEarnCommissions: 'Fais de ton design un vrai produit et touche des commissions sur chaque vente.',
    pleaseSelectStreamer: 'Veuillez sélectionner un streamer',
    
    // Application
    application: 'Candidature Streamer',
    completeProfile: 'Complétez votre profil',
    detectedLocation: 'Location détectée',
    selectLocation: 'Sélectionner votre localisation',
    searchCountry: 'Rechercher un pays...',
    noCountryFound: 'Aucun pays trouvé',
    vision: 'Votre Vision',
    visionPlaceholder: 'Décrivez votre vision et vos objectifs de création de contenu...',
    presentation: 'Votre Présentation',
    presentationPlaceholder: 'Parlez-nous de vous, de votre style de contenu et de ce qui vous rend unique...',
    youtubeLinks: 'Liens YouTube',
    youtubePlaceholder: 'Collez vos URLs de chaîne YouTube ou de vidéos ici...',
    addAnotherLink: 'Ajouter un autre lien',
    socialMedia: 'Réseaux Sociaux',
    socialMediaPlaceholder: 'Vos principaux handles ou liens de réseaux sociaux...',
    followers: 'Nombre de Followers',
    followersPlaceholder: 'Nombre approximatif de followers sur toutes les plateformes...',
    referralCode: 'Code de Parrainage',
    referralPlaceholder: 'Si vous avez un code de parrainage, entrez-le ici...',
    streamerName: 'Nom de Streamer',
    streamerPlaceholder: 'Votre nom de streamer/créateur souhaité...',
    url: 'URL',
    urlPlaceholder: 'Votre site web ou URL de profil...',
    submitApplication: 'Soumettre la Candidature',
    
    // Profile Type
    whatTypeCommunity: 'Quel type de communauté représentez-vous ?',
    profileStreamer: 'Streamer',
    profileInfluencer: 'Influencer',
    profileDiscord: 'Discord',
    profileWebsite: 'Website',
    discordLink: 'Lien Discord',
    discordLinkPlaceholder: 'https://discord.gg/...',
    memberCounter: 'Compteur de membres',
    memberCounterPlaceholder: 'Entrez votre nombre de membres',
    numberOfMembers: 'Nombre de membres',
    enterMemberCount: 'Entrez votre nombre de membres',
    monthlyTraffic: 'Trafic mensuel',
    enterMonthlyTraffic: 'Entrez votre trafic mensuel',
    submittingApplication: 'Soumission de la Candidature...',
    dropZoneCreatedSuccess: 'Création de votre drop zone validée ! Vérifiez vos spams pour vos accès admin.',
    dropZoneCreated: 'Création de votre drop zone validée !',
    checkSpamFolder: 'Vérifiez vos spams pour vos accès admin.',
    
    // Form Fields
    emailAddress: 'Adresse e-mail',
    enterEmailAddress: 'Entrez votre adresse email',
    emailAutoFilled: '✓ Email automatiquement rempli depuis votre compte',
    mainSocialNetwork: 'Réseau social principal (@pseudo)',
    socialPlaceholder: 'ex: @username sur Instagram, TikTok, etc.',
    subscriberCount: 'Nombre d\'abonnés',
    enterSubscriberCount: 'Entrez votre nombre d\'abonnés',
    referralCodeOptional: 'Code de parrainage (facultatif)',
    optionalReferralCode: 'Code de parrainage optionnel',
    
    // Home
    welcome: 'Bienvenue',
    featuredDesigns: 'Designs en Vedette',
    topVoters: 'Top Voteurs',
    topCreators: 'Top Créateurs',
    voteNow: 'Voter Maintenant',
    
    // Common
    loading: 'Chargement...',
    loadingDesigns: 'Chargement des designs...',
    retry: 'Réessayer',
    error: 'Erreur',
    close: 'Fermer',
    cancel: 'Annuler',
    save: 'Sauvegarder',
    edit: 'Modifier',
    delete: 'Supprimer',
    confirm: 'Confirmer',
    yes: 'Oui',
    no: 'Non',
    back: 'Retour',
    search: 'Rechercher',
    filter: 'Filtrer',
    sort: 'Trier',
    
    // Authentication & Profile
    loginToCustomize: 'Connectez-vous pour personnaliser votre page avant que votre communauté ne se mette à créer des designs qui vous ressemblent !',
    loginRequired: 'Connexion requise',
    mustBeLoggedIn: 'Vous devez être connecté pour accéder à cette page',
    byLoggingIn: 'En vous connectant, vous acceptez nos conditions d\'utilisation',
    connection: 'Connexion',
    signIn: 'Se connecter',
    signOut: 'Se déconnecter',
    nextDrop: 'Prochain drop',
    days: 'jours',
    selectLanguage: 'Sélectionner la langue',
    
    // Sidebar Navigation
    general: 'GÉNÉRAL',
    dashboard: 'Tableau de bord',
    website: 'WEBSITE',
    selectedWebsite: 'Site web sélectionné',
    selectWebsite: 'Sélectionner un site web',
    chooseWebsite: 'Choisissez un site web...',
    websiteDomain: 'Domaine du site web',
    loadingWebsites: 'Chargement des sites web...',
    noWebsitesFound: 'Aucun site web trouvé',
    shopify: 'SHOPIFY',
    orders: 'Commandes',
    payment: 'Paiement',
    paymentFromOrders: 'Paiements des commandes',
    paymentListDescription: 'Liste des paiements des transactions de commandes. La création de commande utilisera Shopify Payments une fois intégré.',
    paymentStatus: 'Statut',
    paymentMethod: 'Méthode de paiement',
    shopifyPayments: 'Shopify Payments',
    filterPayments: 'Filtrer les paiements',
    loadingPayments: 'Chargement des paiements...',
    noPaymentsYet: 'Aucun paiement',
    noPaymentsDescription: 'Les paiements apparaîtront ici lorsque des commandes seront créées.',
    noMatchingPayments: 'Aucun paiement correspondant. Modifiez la recherche.',
    orderNumber: 'Commande',
    date: 'Date',
    customer: 'Client',
    amount: 'Montant',
    products: 'Produits',
    customers: 'Clients',
    analytics: 'Analyses',
    marketing: 'Marketing',
    discounts: 'Réductions',
    apps: 'Applications',
    onlineStore: 'Boutique en ligne',
    settings: 'Paramètres',
    backToDashboard: 'Retour au tableau de bord',
    
    // AdminDashboard
    searchPlaceholder: 'Rechercher...',
    currentChallenge: 'Challenge en cours',
    visualValidation: 'Validation des visuels',
    statistics: 'Statistiques',
    archives: 'Archives',
    archived: 'Archivé',
    archive: 'Archiver',
    restore: 'Restaurer',
    uploadsSelected: 'téléchargement(s) sélectionné(s)',
    noUploadsFound: 'Aucun téléchargement trouvé',
    clearFilter: 'Effacer le filtre',
    archivedDesignsFound: 'design(s) archivé(s) trouvé(s)',
    currentChallenges: 'Challenges actuel',
    noChallengeSelected: 'Aucun challenge sélectionné',
    editChallenge: 'Modifier le challenge',
    deleteChallenge: 'Supprimer le challenge',
    loadingChallenges: 'Chargement des challenges...',
    noActiveChallengesFound: 'Aucun challenge actif trouvé',
    selectChallenge: 'Sélectionner un challenge',
    challengeDetails: 'Détails du challenge',
    challengeName: 'Nom du challenge:',
    theme: 'Thématique:',
    notSpecified: 'Non spécifiée',
    expirationDate: 'Date d\'expiration:',
    daysRemaining: 'Jours restants:',
    day: 'jour',
    challengeStatus: 'Statut:',
    expiringSoon: 'Expire bientôt',
    inProgress: 'En cours',
    challengeDescription: 'Description:',
    loadingChallengesEllipsis: 'Chargement des challenges...',
    selectChallengeToSeeDetails: 'Sélectionnez un challenge pour voir les détails',
    progress: 'Progression',
    endNow: 'Terminer maintenant',
    rewards: 'Récompenses',
    firstPlace: '1ère place',
    secondPlace: '2ème place',
    thirdPlace: '3ème place',
    noRewardDefined: 'Aucune récompense définie',
    
    // Challenge Creation Form
    createNewChallenge: 'Créer un nouveau Challenge',
    challengeNameLabel: 'Nom du challenge',
    challengeNamePlaceholder: 'Ex: Ajoli vs Pasta',
    startDate: 'Date de début',
    endDate: 'Date de fin',
    thematic: 'Thématique',
    challengeColor: 'Couleur du challenge',
    challengeDescriptionLabel: 'Description du challenge',
    challengeDescriptionPlaceholder: 'Décrivez le challenge en quelques mots...',
    food: 'Nourriture',
    sport: 'Sport',
    art: 'Art',
    gaming: 'Gaming',
    music: 'Musique',
    rewardPlaceholder: 'Récompense',
    addReward: '+ Ajouter une récompense',
    createChallengeButton: 'Créer le challenge',
    editChallengeButton: 'Modifier le challenge',
    creating: 'Création...',
    editing: 'Modification...',
    
    // Streamer Challenge Interface
    streamerChallengeInterface: 'Interface Streamer Challenge',
    challengeTitle: 'Challenge Ajoli vs Pasta',
    galleryManagement: 'Gestion de la Galerie',
    designByUser: 'Design #{{number}} par {{user}}',
    streamControls: 'Contrôles du stream',
    displayMode: 'Mode d\'affichage',
    faceToFace: 'Face à face',
    timer: 'Minuteur',
    start: 'Démarrer',
    actions: 'Actions',
    startStop: 'Démarrer/arrêter',
    endStream: 'Terminer stream',
    overlayPreview: 'Aperçu de l\'overlay',
    startStreamButton: 'Commencer le stream',
    
    // Visual Validation Tab
    loadingPendingDesigns: 'Chargement des designs en attente...',
    showLabel: 'Afficher:',
    perPage: 'par page',
    statusLabel: 'Statut:',
    pendingStatus: 'En attente',
    pendingAKS: 'En attente AKS',
    approvedStatus: 'Approuvés',
    rejectedStatus: 'Rejetés',
    all: 'Tous',
    selectAll: 'Sélectionner tout',
    deselectAll: 'Désélectionner tout',
    deleteSelected: 'Supprimer',
    design: 'design',
    totalLabel: 'au total',
    pendingValidation: 'en attente de validation',
    selected: 'sélectionné',
    showingResults: 'Affichage de',
    to: 'à',
    results: 'résultats',
    noDesign: 'Aucun design',
    approve: 'Approuver',
    reject: 'Rejeter',
    publish: 'Publier',
    published: 'Publié',
    editProduct: 'Modifier le produit',
    
    // Available Products
    availableType: 'Type Disponible',
    availableTypeAll: 'Type Disponible (Tous)',
    availableFor: 'Disponible pour',
    noRestrictions: 'Aucune restriction — tous les types de produits',

    // Archive
    archiveDesigns: 'Archiver les designs',
    newFolder: 'Nouveau dossier',
    existingFolder: 'Dossier existant',
    archiveName: 'Nom de l\'archive',
    archiveNamePlaceholder: 'Entrer le nom du dossier',
    archiveDescPlaceholder: 'Entrer une description',
    selectFolder: 'Sélectionner un dossier',
    deleteFolder: 'Supprimer le dossier',
    deleteFolderConfirm: 'Êtes-vous sûr de vouloir supprimer',
    emptyFolder: 'Ce dossier est vide',
    noArchiveFolders: 'Aucun dossier d\'archive',
    archiveFolderHint: 'Archivez des designs depuis la vue uploads pour créer des dossiers',

    // Final AdminDashboard translations
    selectedProducts: 'Produits sélectionnés:',
    displayingResults: 'Affichage de {start} à {end} sur {total} design{plural}',
    price: 'Prix:',
    updatedOn: 'Mis à jour:',
    
    // UserList
    userManagement: 'Gestion des Utilisateurs',
    searchByNameEmail: 'Rechercher par nom ou email...',
    displayedUsers: 'Utilisateurs affichés',
    totalOnPlatform: 'Total sur la plateforme',
    filteredResults: 'Résultats filtrés',
    adminsCount: 'Admins',
    inResults: 'Dans les résultats',
    usersCount: 'Utilisateurs',
    roleLabel: 'Rôle:',
    userRole: 'Utilisateur',
    adminRole: 'Admin',
    resetFilters: 'Réinitialiser',
    filtered: 'filtré',
    among: 'parmi',
    page: 'Page',
    userList: 'Liste des Utilisateurs',
    userColumn: 'Utilisateur',
    registrationDate: 'Date d\'inscription',
    updating: 'Mise à jour...',
    processing: 'Traitement...',
    unblockUser: 'Débloquer utilisateur',
    blockUser: 'Bloquer utilisateur',
    loadingUsers: 'Chargement des utilisateurs...',
    noUsersFound: 'Aucun utilisateur trouvé',
    usersWillAppear: 'Les utilisateurs apparaîtront ici une fois qu\'ils se seront inscrits',
    noUsersMatchFilters: 'Aucun utilisateur ne correspond aux filtres',
    tryModifyingCriteria: 'Essayez de modifier vos critères de recherche',
    resetFiltersButton: 'Réinitialiser les filtres',
    blockUserTitle: 'Bloquer l\'utilisateur',
    unblockUserTitle: 'Débloquer l\'utilisateur',
    actionCanBeUndone: 'Cette action peut être annulée',
    areYouSureToBlock: 'Êtes-vous sûr de vouloir bloquer l\'utilisateur :',
    areYouSureToUnblock: 'Êtes-vous sûr de vouloir débloquer l\'utilisateur :',
    userWillNotAccess: 'L\'utilisateur ne pourra plus accéder à la plateforme',
    userWillAccess: 'L\'utilisateur pourra à nouveau accéder à la plateforme',
    block: 'Bloquer',
    unblock: 'Débloquer',
    userBlockedSuccess: 'Utilisateur "{userName}" a été bloqué avec succès',
    userUnblockedSuccess: 'Utilisateur "{userName}" a été débloqué avec succès',
    errorMessage: 'Erreur: {message}',
    networkErrorBlock: 'Erreur réseau: Impossible de bloquer l\'utilisateur',
    networkErrorUnblock: 'Erreur réseau: Impossible de débloquer l\'utilisateur',
    networkErrorUpdateRole: 'Erreur réseau: Impossible de mettre à jour le rôle utilisateur',
    
    // Settings
    settingsTitle: 'Paramètres',
    manageInformationPreferences: 'Gérez vos informations et préférences',
    updateInformationTab: 'Mettre à jour les informations',
    changePasswordTab: 'Changer le mot de passe',
    updateInformationTitle: 'Mettre à jour les informations',
    manageProfileSocialMedia: 'Gérez les informations de votre profil et les liens de réseaux sociaux',
    addYoutubeLink: 'Ajouter un lien YouTube',
    youtubeUrlPlaceholder: 'https://www.youtube.com/watch?v=...',
    aboutPlaceholder: 'Parlez-nous de vous et de votre contenu...',
    messageSection: 'Messagerie',
    messagePlaceholder: 'Votre message personnalisé...',
    updateInformationButton: 'Mettre à jour les informations',
    changePasswordTitle: 'Changer le mot de passe',
    updatePasswordSecurity: 'Mettez à jour votre mot de passe pour sécuriser votre compte',
    currentPassword: 'Mot de passe actuel',
    currentPasswordPlaceholder: 'Entrez votre mot de passe actuel',
    newPassword: 'Nouveau mot de passe',
    newPasswordPlaceholder: 'Entrez votre nouveau mot de passe',
    confirmNewPassword: 'Confirmer le nouveau mot de passe',
    confirmPasswordPlaceholder: 'Confirmez votre nouveau mot de passe',
    passwordStrength: 'Force du mot de passe',
    passwordRequirements: 'Le mot de passe doit contenir au moins 8 caractères, une majuscule, une minuscule, un chiffre et un caractère spécial',
    passwordsMatch: 'Les mots de passe correspondent',
    passwordsDoNotMatch: 'Les mots de passe ne correspondent pas',
    updatePasswordButton: 'Mettre à jour le mot de passe',
    informationUpdatedSuccess: 'Informations mises à jour avec succès !',
    failedUpdateInformation: 'Échec de la mise à jour des informations',
    errorUpdatingInformation: 'Erreur lors de la mise à jour des informations. Veuillez réessayer.',
    enterCurrentPassword: 'Veuillez entrer votre mot de passe actuel',
    enterNewPassword: 'Veuillez entrer un nouveau mot de passe',
    passwordTooShort: 'Le mot de passe doit contenir au moins 8 caractères',
    passwordRequirementsNotMet: 'Le mot de passe doit contenir une majuscule, une minuscule, un chiffre et un caractère spécial',
    passwordsDoNotMatchError: 'Les mots de passe ne correspondent pas',
    passwordUpdatedSuccess: 'Mot de passe mis à jour avec succès !',
    failedUpdatePassword: 'Échec de la mise à jour du mot de passe',
    errorUpdatingPassword: 'Erreur lors de la mise à jour du mot de passe. Veuillez réessayer.',
    
    // Settings - Additional Fields
    name: 'Nom',
    namePlaceholder: 'Votre nom complet',
    country: 'Pays',
    searchCountryPlaceholder: 'Rechercher un pays...',
    socialMediaLabel: 'Réseaux Sociaux',
    socialMediaTypePlaceholder: '@pseudo',
    subscriberCountLabel: 'Nombre d\'abonnés',
    subscriberCountPlaceholder: '1000 abonnés, 5K, 10.2M, etc.',
    servicesSection: 'Services',
    serviceUrlPlaceholder: 'https://exemple.com',
    serviceCaptionPlaceholder: 'ex: Meilleures Offres de Jeu',
    uploadNewImage: 'Téléverser Nouvelle Image',
    changePhoto: 'Profil/Logo',
    profilePhoto: 'Profil',
    logoPhoto: 'Logo',
    
    // Media Gallery
    mediaGallery: 'Galerie Média',
    manageImageCollection: 'Gérez votre collection d\'images professionnelle',
    images: 'Images',
    dropImagesHere: 'Déposez les images ici',
    orClickToSelectMultiple: 'ou cliquez pour sélectionner (multiple)',
    browseFiles: 'Parcourir les fichiers',
    yourImages: 'Vos Images',
    profile: 'profil',
    image: 'image',
    primary: 'principal',
    
    // Logo Section
    uploadLogo: 'Téléverser Logo',
    uploadLogoDescription: 'Téléversez des images pour votre logo. Le premier logo sera utilisé comme logo principal.',
    dropLogoHere: 'Déposez le logo ici',
    orClickToSelect: 'ou cliquez pour sélectionner',
    yourLogos: 'Vos Logos',
    mainLogo: 'logo principal',
    logoNumber: 'logo #',
    
    // Language Button
    addLanguage: 'Langue',
    
    // Tips Section
    tips: 'Astuces :',
    tipSelectText: 'Sélectionnez le texte et faites un clic droit pour afficher les options de formatage',
    tipChooseFormatting: 'Choisissez parmi Gras, Italique, Souligné et Couleurs',
    tipCopyFormatted: 'Copiez le texte formaté d\'autres sources pour préserver le formatage',
    
    // Services Section
    noServicesAdded: 'Aucun service ajouté. Cliquez sur "Ajouter un Service" pour commencer.',
    addServiceButton: 'Ajouter un Service',
    
    // Website URL
    visitOurWebsite: 'Visitez notre site web',
    
    // AdminDashboardOwner
    overviewTab: 'Vue d\'ensemble',
    userManagementTab: 'Gestion des Streamers',
    analyticsTab: 'Analyses',
    applicationsTab: 'Candidatures',
    suggestionsTab: 'Suggestions',
    imageManagerTab: 'Gestionnaire d\'images',
    welcomeAdminDashboard: 'Bienvenue sur le tableau de bord administrateur',
    connectedAs: 'Vous êtes connecté en tant que:',
    ownerStatus: 'Statut du propriétaire:',
    informationLabel: 'Information',
    selectWebsiteInSidebar: 'Sélectionnez un site web dans la barre latérale pour voir les uploads avec statut 9.',
    quickActions: 'Actions rapides',
    manageUsers: 'Gérer les Streamers',
    viewModifyUserAccounts: 'Voir et modifier les comptes streamers',
    viewAnalytics: 'Voir les analyses',
    detailedStatisticsReports: 'Statistiques et rapports détaillés',
    systemSettings: 'Paramètres système',
    globalConfiguration: 'Configuration globale',
    userManagementTitle: 'Gestion des Streamers',
    userManagementFeatureComingSoon: 'Gérez vos streamers approuvés et leur statut de compte.',
    inDevelopment: 'Actif',
    userManagementSectionDescription: 'Cette section permet de bloquer ou débloquer des streamers et de les notifier par e-mail.',
    loadingStreamers: 'Chargement des streamers...',
    noStreamersFound: 'Aucun streamer approuvé trouvé.',
    streamerEmail: 'E-mail',
    streamerNameLabel: 'Nom du Streamer',
    accountStatus: 'Statut',
    actionsColumn: 'Actions',
    blockStreamer: 'Bloquer le Streamer',
    unblockStreamer: 'Débloquer le Streamer',
    blockReason: 'Raison du blocage',
    blockReasonPlaceholder: 'Entrez la raison du blocage de ce streamer...',
    confirmBlock: 'Confirmer le blocage',
    cancelAction: 'Annuler',
    blocked: 'Bloqué',
    activeStatus: 'Actif',
    blockingStreamer: 'Blocage du streamer...',
    unblockingStreamer: 'Déblocage du streamer...',
    streamerBlockedSuccess: 'Streamer bloqué avec succès et notifié par e-mail.',
    streamerUnblockedSuccess: 'Streamer débloqué avec succès et notifié par e-mail.',
    errorBlockingStreamer: 'Erreur lors du blocage du streamer. Veuillez réessayer.',
    errorUnblockingStreamer: 'Erreur lors du déblocage du streamer. Veuillez réessayer.',
    blockReasonRequired: 'Veuillez fournir une raison pour le blocage.',
    analyticsStatisticsTitle: 'Analyses et statistiques',
    analyticsFullDashboardComingSoon: 'Tableau de bord analytique complet à venir.',
    suggestionsManagementTitle: 'Gestion des Suggestions',
    streamerSuggestionsSubmittedByCommunity: 'Suggestions de streamers soumises par la communauté',
    loadingSuggestions: 'Chargement des suggestions...',
    errorLoadingApplications: 'Erreur lors du chargement des candidatures: {message}',
    networkErrorLoadingApplications: 'Erreur lors du chargement des candidatures',
    errorLoadingSuggestions: 'Erreur lors du chargement des suggestions: {message}',
    networkErrorLoadingSuggestions: 'Erreur lors du chargement des suggestions',
    errorApproving: 'Erreur lors de l\'approbation: {error}',
    networkErrorApproving: 'Erreur réseau lors de l\'approbation',
    errorRejecting: 'Erreur lors du rejet: {error}',
    networkErrorRejecting: 'Erreur réseau lors du rejet',
    errorLoadingUploads: 'Erreur lors du chargement des uploads',
    networkErrorLoadingUploads: 'Erreur réseau lors du chargement des uploads',
    apiError: 'Erreur API: {status}',
    loadingUploads: 'Chargement des uploads...',
    unknownError: 'Erreur inconnue',
    uploadsFoundPending: '{count} upload(s) en attente trouvé(s)',
    noPendingImages: 'Aucune image en attente',
    
    // Toast Messages - AdminDashboard & AdminDashboardOwner
    uploadApprovedSuccess: 'Upload approuvé avec succès!',
    uploadRejectedSuccess: 'Upload rejeté avec succès!',
    uploadDeletedSuccess: 'Upload supprimé avec succès!',
    errorPublishStatusUpdate: 'Erreur lors de la mise à jour du statut de publication',
    productCreatedShopifySuccess: 'Produit créé avec succès sur Shopify!',
    errorCreatingProduct: 'Erreur lors de la création du produit',
    challengeCreatedSuccess: '🎉 Challenge créé avec succès!',
    challengeModifiedSuccess: '🎉 Challenge modifié avec succès!',
    challengeDeletedSuccess: '🗑️ Challenge supprimé avec succès!',
    errorDeletingChallenge: 'Erreur lors de la suppression du challenge',
    challengeEndedSuccess: '🏁 Challenge terminé avec succès!',
    errorEndingChallenge: 'Erreur lors de la terminaison du challenge',
    errorCreatingChallenge: 'Erreur lors de la création du challenge',
    errorModifyingChallenge: 'Erreur lors de la modification du challenge',
    noDesignSelected: '❌ Aucun design sélectionné',
    designsDeletedSuccess: '🗑️ {count} design(s) supprimé(s) avec succès!',
    designsDeletedPartial: '⚠️ {successCount} design(s) supprimé(s), {failedCount} échec(s)',
    errorDeletingAllDesigns: '❌ Échec de la suppression de tous les designs sélectionnés',
    errorDeletingDesigns: '❌ Erreur lors de la suppression des designs',
    noWebsiteSelected: 'Aucun site web sélectionné',
    uploadSentForReview: 'Upload envoyé au streamer pour révision!',
    applicationApprovedSuccess: 'Candidature approuvée avec succès! Compte administrateur créé.',
    applicationRejectedSuccess: 'Candidature rejetée avec succès.',
    uploadsLoadedCount: 'Chargé {count} uploads pour {website}',
    rejectionReasonRequired: 'Raison de rejet requise',
    selectRejectionReason: 'Veuillez sélectionner une raison de rejet',
    
    // Blur Image Feature
    blurImage: 'Flouter l\'image',
    blurReasonRequired: 'Veuillez sélectionner une raison de floutage',
    approveWithBlur: 'Approuver avec floutage',
    imageBlurredSuccess: 'Image approuvée avec floutage avec succès !',
    selectBlurReason: 'Sélectionner une raison...',
    viewImage: 'Voir l\'image',
    imageBlurred: 'Cette image est floutée',
    explicitContentWarning: 'Cette image affiche un contenu explicite. Vous devez confirmer que vous avez plus de 18 ans pour continuer.',
    
    // Mockup Generation
    generateMockup: 'Générer un aperçu',
    selectProductType: 'Sélectionnez un type de produit',
    mockupPreview: 'Aperçu du produit',
    generatingMockup: 'Génération de l\'aperçu...',
    mockupGenerationTime: 'Cela peut prendre 10-30 secondes',
    mockupError: 'Échec de la génération',
    mockupGenerationFailed: 'Impossible de générer l\'aperçu. Veuillez réessayer.',
    mockupGenerationError: 'Une erreur est survenue lors de la génération de l\'aperçu.',
    openFullSize: 'Ouvrir en taille réelle',
    
    // Image Manager
    manageAllImages: 'Gérer toutes les images téléchargées sur tous les sites',
    totalImages: 'Total des images',
    filterByWebsite: 'Site web:',
    allWebsites: 'Tous les sites',
    clearFiltersButton: 'Effacer les filtres',
    noImagesFound: 'Aucune image trouvée',
    noImagesMatchCriteria: 'Aucune image ne correspond aux filtres actuels.',
    loadingImages: 'Chargement des images...',
    submittedAt: 'Soumis',
    confirmDeletion: 'Confirmer la suppression',
    thisActionCannotBeUndone: 'Cette action est irréversible',
    imageDetails: 'Détails de l\'image',
    untitled: 'Sans titre',
    areYouSureDelete: 'Êtes-vous sûr de vouloir supprimer cette image ?',
    imageWillBeRemoved: 'Cette image sera supprimée définitivement.',
    errorLoadingImages: 'Erreur lors du chargement des images',
    errorDeletingImage: 'Erreur lors de la suppression de l\'image',
    
    errorLoadingChallenges: 'Erreur lors du chargement des challenges',
    networkErrorLoadingChallenges: 'Erreur réseau lors du chargement des challenges',
    noChallengesFound: 'Aucun challenge trouvé',
    createFirstChallenge: 'Créez votre premier challenge pour commencer à engager votre communauté!',
    createChallenge: 'Créer un challenge',
    refreshPage: 'actualiser la page',
    ifYouThinkError: 'si vous pensez qu\'il y a une erreur',
    noChallengesWithFilters: 'Aucun challenge trouvé avec les filtres actuels',
    or: 'Ou',
    challengesList: 'Liste des Challenges',
    searchChallengePlaceholder: 'Rechercher un challenge...',
    upcoming: 'À venir',
    finished: 'Terminé',
    created: 'Créé',
    allStatuses: 'Tous les statuts',
    errorCreatingAccount: 'Erreur lors de la création du compte',
    loginError: 'Erreur de connexion',
    
    // Application.js Toast Messages
    pleaseAddProfilePhoto: 'Veuillez ajouter une photo de profil',
    pleaseWriteVision: 'Veuillez rédiger votre vision',
    pleaseWritePresentation: 'Veuillez rédiger votre présentation',
    pleaseIndicateSocialMedia: 'Veuillez indiquer votre réseau social principal',
    pleaseIndicateFollowerCount: 'Veuillez indiquer votre nombre d\'abonnés',
    pleaseIndicateStreamerName: 'Veuillez indiquer votre nom de streamer/site',
    streamerNameExists: 'Ce nom de streamer existe déjà. Veuillez en choisir un autre.',
    authenticationError: 'Erreur d\'authentification. Veuillez vous reconnecter.',
    invalidImageFormat: 'Veuillez télécharger un fichier image valide (PNG, JPEG, JPG ou WebP)',
    fileTooLargeProfile: 'Le fichier est trop volumineux ({size}MB). Taille maximum: 10MB.',
    fileTooLargeUpload: 'Le fichier est trop volumineux. Taille maximum : 10 Mo.',
    fileSizeNote: '⚠️ Taille maximale du fichier: 10MB par fichier',
    designUploadImportant: 'IMPORTANT : Téléchargez votre design seul sur un fond transparent.',
    designUploadNoMockups: 'Ne soumettez pas de mock-ups (designs déjà placés sur des vêtements ou objets).',
    sessionExpiredLogin: 'Session expirée. Veuillez vous connecter pour soumettre des candidatures.',
    authenticationErrorOccurred: 'Une erreur d\'authentification s\'est produite.',
    
    // Submit.js Messages
    invalidFileFormat: 'Format de fichier non valide pour l\'aperçu. Veuillez utiliser PNG, JPG ou WebP.',
    fileTooLarge: 'Le fichier d\'aperçu est trop volumineux. Maximum 10MB.',
    
    // TopVoters page
    discoverActiveMembers: 'Découvrez les membres les plus actifs de notre communauté qui soutiennent leurs créations préférées.',
    votersCount: 'votant',
    votersCountPlural: 'votants',
    updatedRealTime: 'Mis à jour en temps réel',
    retryButton: 'Réessayer',
    noVotersYet: 'Aucun votant pour le moment',
    beFirstToVote: 'Soyez le premier à voter pour vos designs préférés !',
    rank: 'Rang',
    totalVoters: 'Total',
    
    loginToVoteSubmit: 'Connectez-vous pour voter et soumettre vos créations',
    backToHome: 'Retour à l\'accueil',
    myProfile: 'Mon Profil',
    loggedInAs: 'Connecté en tant que',
    loggingIn: 'Connexion...',
    
    // TopCreators page
    discoverTopCreatorsGlobal: 'Découvrez les créateurs les plus talentueux qui ont soumis leurs designs.',
    discoverTopCreatorsForShop: 'Découvrez les créateurs les plus talentueux qui ont soumis leurs designs pour la boutique {shopName}.',
    creatorsCount: 'créateur',
    creatorsCountPlural: 'créateurs',
    topCreatorsLoadError: 'Impossible de charger les top créateurs. Réessayez plus tard.',
    noCreatorsYet: 'Aucun créateur pour le moment',
    beFirstToSubmitCreators: 'Soyez le premier à soumettre vos créations !',
    designsColumn: 'Designs',
    designLabel: 'design',
    designLabelPlural: 'designs',
    anonymousCreator: 'Créateur anonyme',
    profilePictureFromGoogle: 'Photo de profil Google',
    footerDesignsTotal: 'Designs',
    footerVotesTotal: 'Votes',
    
    // Loading & Messages
    loadingTopVoters: 'Chargement des top votants...',
    loadingTopCreators: 'Chargement des top créateurs...',
    sendingInProgress: 'Envoi en cours...',
    submitMyDesign: 'Soumettre mon design',
    anErrorOccurred: 'Une erreur est survenue :',
    submitUploadFailed: 'Échec de l\'envoi. Veuillez réessayer.',
    submitSessionExpired: 'Votre session a peut-être expiré. Votre design n\'a pas été soumis. Vous pouvez vous reconnecter et réessayer, ou continuer sans connexion avec un nombre limité de soumissions par jour.',
    submitLimitReached: 'Vous avez atteint la limite de soumissions pour aujourd\'hui. Veuillez réessayer demain.',
    submitGenericError: 'Une erreur est survenue lors de la soumission de votre design. Veuillez réessayer.',
    creationTitle: 'Titre de la création',
    catchyTitlePlaceholder: 'Un titre accrocheur pour votre création',
    
    // Voting & Designs
    yourTurnToVote: 'A toi de voter !',
    discoverProposedCreations: 'Découvre les créations proposées et vote pour celles que tu veux voir produites.',
    
    // Pending Page
    applicationsProcessed: 'Les candidatures sont généralement traitées dans un délai de 24-48 heures. Revenez bientôt pour voir le profil de ce streamer !',
    becomeStreamer: 'Devenir Streamer',
    areYouThisStreamer: 'Vous êtes ce streamer ? Contactez notre équipe si vous avez des questions sur votre candidature.',
    
    // Admin & Settings
    users: 'Utilisateurs',
    administration: 'Administration',
    submissions: 'Soumissions',
    challenges: 'Challenges',
    
    // Home page
    giveLifeToCommunity: 'Donne vie à ta communauté !',
    ultimatePlatformStreamers: 'La plateforme ultime pour les streamers, où les idées de ta communauté prennent vie. Génère des revenus, engage ceux qui te suivent et offre-leur une expérience exclusive pour te soutenir.',
    createDropZone: 'Créer ma Drop Zone',
    seeDropZones: '🔍 Voir les Drop Zones',
    threeRolesMission: 'Trois rôles,',
    oneMission: ' une même mission',
    unlockCreativity: 'Libérer la créativité.',
    creator: 'Créateur',
    contentCreator: 'de contenu',
    earn30Percent: 'Gagne <span class="text-purple-400 font-bold">30 % des bénéfices</span> sur chaque produit vendu dans ta Drop Zone.',
    diversifyRevenue: 'Diversifie tes revenus en gardant le contrôle sur tes créations.',
    strengthenEngagement: 'Renforce l\'engagement de ta communauté avec des <span class="text-purple-400 font-bold">événements exclusifs</span>, des <span class="text-purple-400 font-bold">batailles créatives</span> et des <span class="text-purple-400 font-bold">giveaways</span>.',
    hundredPercentManaged: 'Profite d\'une <span class="text-purple-400 font-bold">gestion 100 % prise en charge</span> : boutique, production, expédition… tout est géré pour toi.',
    createStrongBond: 'Crée un lien fort avec ta communauté grâce à des designs uniques et créatifs.',
    artistDesigner: 'Artiste · Designer ·',
    promptKing: 'Roi du prompt',
    propose10Percent: 'Propose tes créations et reçois <span class="text-cyan-400 font-bold">10 % des bénéfices</span> sur chaque produit vendu avec ton design.',
    getArtistBadge: 'Obtiens un <span class="text-cyan-400 font-bold">badge d\'artiste</span> et gagne en visibilité auprès des communautés de streamers.',
    participateGiveaways: 'Participe à des <span class="text-cyan-400 font-bold">giveaways exclusifs</span> réservés aux artistes et designers.',
    expressFreelyCreativity: 'Exprime librement ta créativité et donne vie à tes idées, avec ou sans IA.',
    proposeCreation: 'Proposer ma création',
    member: 'Membre',
    communityMember: 'de la communauté',
    supportCreators: 'Soutiens directement tes créateurs préférés à chaque achat.',
    becomeVIP: '<span class="text-yellow-400 font-bold">Deviens VIP</span> et débloque des <span class="text-yellow-400 font-bold">récompenses exclusives</span> : designs inédits, événements spéciaux, interactions privilégiées.',
    winGoldenTicket: '<span class="text-yellow-400 font-bold">Gagne le Ticket d\'Or</span> : chaque achat te donne une chance d\'obtenir ce sésame et d\'accéder à des cadeaux uniques (appel privé, produits dédicacés, etc.).',
    exclusiveDigitalContent: 'Profite de <span class="text-yellow-400 font-bold">contenus numériques exclusifs</span> : fonds d\'écran, sonneries et créations offertes par tes artistes préférés.',
    discoverDropZones: 'Découvrir les Drop Zones',
    dropZonesToDiscover: 'Les Drop Zones à découvrir',
    createDropZoneEmoji: 'Créer ma Drop Zone ✏️',
    suggestCreator: 'Suggérer un créateur ✏️',
    frequentQuestions: 'Questions fréquentes',
    howVotingWorks: 'Comment fonctionne le vote des créations ?',
    eachMemberCanVote: 'Chaque membre peut voter pour autant de créations qu\'il le souhaite.',
    mostPopularProduced: 'Les plus plébiscitées seront produites pour le prochain Drop.',
    whenWinnersAnnounced: 'Quand sont annoncés les designs gagnants ?',
    endOfVotingPeriod: 'À la fin de chaque période de vote, directement sur la Drop Zone concernée.',
    howSubmitCreation: 'Comment soumettre ma création ?',
    submitTabUpload: 'Dans l\'onglet Soumettre, téléverse ton design, choisis les produits, accepte les conditions et valide en un clic.',
    howMuchEarn: 'Combien je gagne si ma création est retenue ?',
    earn10PercentBenefits: 'Tu touches 10 % des bénéfices générés par chaque vente de ton design.',
    whichProducts: 'Sur quels produits seront imprimés les designs ?',
    creationsProducedSupports: 'Les créations peuvent être produites sur plusieurs supports : t-shirts, casquettes, totebags, mugs et posters. D\'autres supports pourront être ajoutés à l\'avenir.',
    whatDeadline: 'Quelle est la date limite pour soumettre une création ?',
    noDeadline: 'Aucune date limite : tu peux soumettre tes idées à tout moment.',
    onlySpecialEvents: 'Seules les participations à un événement ou un thème spécial auront une date de clôture indiquée.',
    moreDropsFuture: 'Y aura-t-il d\'autres Drops par la suite ?',
    yesNewDrops: 'Oui ! De nouveaux Drops sont prévus en continu, avec de nouveaux thèmes et de nouvelles créations',
    seeMore: 'Voir plus',
    seeLess: 'Voir moins',
    proposeStreamer: 'Proposer un streamer',
    enterStreamerName: 'Entrez le nom du streamer...',
    suggest: 'Suggérer',
    suggestionLimitReached: 'Limite de suggestions atteinte.',
    suggestionSuccessThanks: 'Merci ! Votre suggestion "{name}" a été envoyée avec succès.',
    suggestionRateLimitWait:
      'Vous avez déjà fait une suggestion récemment. Veuillez patienter encore {hours}h {minutes}min avant d\'en faire une nouvelle.',
    suggestStreamerNameRequired: 'Le nom du streamer est requis.',
    suggestStreamerNameTooLong: 'Le nom du streamer est trop long (max 100 caractères).',
    suggestStreamerNameInvalid:
      'Le nom du streamer ne peut contenir que des lettres, chiffres, espaces, tirets et underscores.',
    suggestInvalidDataFormat: 'Format de données invalide.',
    errorSendingSuggestion: 'Erreur lors de l\'envoi de la suggestion.',
    errorSendingSuggestionRetry: 'Erreur lors de l\'envoi de la suggestion. Veuillez réessayer.',
    
    // Footer
    platformDescription: 'Plateforme de merchandising où les communautés peuvent soumettre, voter et acheter des designs uniques.',
    quickLinks: 'Liens rapides',
    home: 'Accueil',
    information: 'Informations',
    contact: 'Contact',
    legalInformation: 'Informations légales',
    termsAndConditions: 'Termes et Conditions de Pimp My Drop',
    termsSection4Title: 'Cession des Droits sur les Designs et Rémunération',
    termsImportant: 'Important',
    termsSection4ImportantText: 'En téléversant un design sur "pimp my drop", vous serez explicitement informé et devrez consentir au fait que vous cédez l\'intégralité de vos droits de propriété intellectuelle sur ce design à "pimp my drop". Cette cession est volontaire, définitive et irrévocable à partir du moment du téléversement.',
    termsSection4AllowsUs: 'Cela nous permet d\'utiliser, de modifier, de reproduire et de commercialiser le design, notamment pour :',
    termsSection4Bullet1: 'La création et la vente d\'objets via notre boutique Shopify ;',
    termsSection4Bullet2: 'La promotion, la publicité et l\'animation communautaire sur les réseaux sociaux (Instagram, Twitter, Discord, etc.) et autres supports marketing de "pimp my drop", sans limitation de durée ou de territoire.',
    termsSection4MinorsTitle: 'Politique concernant les mineurs',
    termsSection4MinorsText: 'Toute personne physique, y compris mineure, est autorisée à soumettre des designs sur la plateforme. Toutefois, conformément à la législation en vigueur, les utilisateurs mineurs ne sont pas éligibles au programme de rémunération ou de partage de revenus. En soumettant un design, l\'utilisateur mineur (et son représentant légal) accepte que cette contribution soit effectuée à titre purement gracieux et bénévole, sans autre contrepartie que la visibilité potentielle offerte par notre plateforme.',
    legalNotices: 'Mentions Légales',
    allRightsReserved: 'Tous droits réservés',
    
    // Submit page specific
    termsAgreement: 'Je déclare sur l\'honneur être l\'auteur original de ce design et qu\'il ne viole aucun droit d\'auteur ou marque déposée. J\'accepte les termes du',
    cessionContract: 'contrat de cession',
    andUnderstand: 'et comprends que la rémunération de 10% est réservée aux utilisateurs majeurs.',
    optional: '(Optionnel)',
    previewFileRequired: 'Le fichier d\'aperçu est requis',
    selectAtLeastOneProduct: 'Veuillez sélectionner au moins un produit adapté pour votre design',
    fillAllRequiredFields: 'Veuillez remplir tous les champs obligatoires',
    mustAcceptTerms: 'Vous devez accepter les termes du contrat de cession',
    challenge: 'Challenge',
    searchChallenge: 'Rechercher un challenge...',
    noChallengeFound: 'Aucun challenge trouvé',
    noStreamerFound: 'Aucun streamer trouvé',
    previewFiles: 'Fichiers d\'aperçu (PNG, WebP)',
    dropFileHere: 'Déposer le fichier ici',
    dragOr: 'Glisser ou',
    browse: 'Parcourir',
    pngJpgWebp: 'PNG, WebP (fond transparent uniquement)',
    removeFile: 'Supprimer le fichier',
    onlyPngWebpAllowed: 'Seuls les formats PNG et WebP sont autorisés.',
    transparentBackgroundRequired: 'L\'image doit avoir un fond transparent (sans arrière-plan). Veuillez supprimer l\'arrière-plan et réessayer.',
    checkingTransparency: 'Vérification de la transparence...',
    verifyingNoBackground: 'Vérification que l\'image n\'a pas de fond',
    suitableProducts: 'Produits adaptés pour ce design',
    cap: 'Casquette',
    
    // How it works section
    tenPercentBenefits: '10 % de bénéfices',
    receive10Percent: 'Reçois 10 % des bénéfices nets sur chaque produit vendu avec ton design.',
    dashboardTracking: 'Un tableau de bord te permet de suivre tes ventes à chaque étape.',
    noEarningsCap: 'Pas de plafond sur les gains',
    automaticPayments: 'Paiements automatiques en fin de mois',
    preciseTracking: 'Suivi précis des ventes et revenus',
    productVariety: 'Une variété de produits',
    creationsPrinted: 'Tes créations peuvent être imprimées sur différents supports :',
    tshirtsSweatshirts: 'T-shirts et sweatshirts',
    capsAccessories: 'Casquettes et accessoires',
    mugsCups: 'Mugs et tasses',
    muchMore: 'Et bien plus encore !',
    viralExposure: 'Exposition virale',
    networkVisibility: 'Profite de la visibilité de notre réseau pour donner un vrai coup de projecteur à tes idées.',
    millionViews: 'Plus d\'1 million de vues par trimestre',
    hundredsPartners: 'Des centaines de comptes partenaires',
    internationalDiffusion: 'Diffusion internationale sur les réseaux sociaux',
    dropSystem: 'Système de drops',
    functionByDrops: 'Nous fonctionnons par drops (lancements organisés) pour créer de l\'engouement et booster la demande.',
    announcedPeriods: 'Périodes de vote et de lancement annoncées',
    trackingTools: 'Outils de suivi pour maximiser tes gains',
    massiveCommunication: 'Communication massive autour de chaque drop',
    
    // Shop
    comingSoon: 'Bientôt disponible',
    shopComingSoon: 'Le shop arrive prochainement',
    shopDiscoverProducts: 'Découvrez les produits exclusifs de nos streamers',
    findPerfectProduct: 'Trouvez le produit idéal',
    searchProducts: 'Rechercher des produits...',
    orderNow: 'Commander',
    outOfStock: 'Rupture de stock',
    
    // Shop Create Order Modal
    shopCreateOrder: 'Créer une commande',
    shopFillDetailsToPlaceOrder: 'Remplissez vos informations pour passer commande',
    shopProducts: 'Produits',
    shopProduct: 'Produit',
    shopQuantity: 'Quantité',
    shopTotal: 'Total',
    shopPayment: 'Paiement',
    shopSubtotal: 'Sous-total',
    shopShippingInformation: 'Informations de livraison',
    shopFirstName: 'Prénom',
    shopLastName: 'Nom',
    shopCustomerEmail: 'E-mail du client',
    shopAddress: 'Adresse',
    shopPhone: 'Téléphone',
    shopPhoneRequired: 'Veuillez entrer un numéro de téléphone valide (au moins 6 chiffres)',
    shopCity: 'Ville',
    shopCountry: 'Pays',
    shopZipCode: 'Code postal',
    shopGenerateMockup: 'Générer un mockup',
    shopSelectProductType: 'Sélectionnez un type de produit',
    shopMockupPreview: 'Aperçu du mockup',
    shopDelete: 'Supprimer',
    shopEditMockup: 'Modifier le mockup',
    shopCancel: 'Annuler',
    shopPaymentCompleteOrder: 'Finalisez votre commande',
    shopOrderTotal: 'Total de la commande',
    shopPaymentDetailsMock: 'Détails de paiement (simulation - pas d\'API pour l\'instant)',
    shopBogusGatewayTitle: 'Bogus Gateway (Sandbox)',
    shopBogusGatewayHint: 'Carte test : 1 = succès, 2 = refusé, 3 = erreur. Aucun prélèvement réel.',
    shopCardType: 'Type de carte',
    shopCardNumberRequired: 'Veuillez entrer un numéro de carte valide',
    shopCardNumber: 'Numéro de carte',
    shopNameOnCard: 'Nom sur la carte',
    shopExpiry: 'Expiration',
    shopCVV: 'CVV',
    shopBack: 'Retour',
    shopPayCreateOrder: 'Payer et créer la commande',
    shopProcessing: 'Traitement...',
    shopOrderReceipt: 'Reçu de commande',
    shopCustomer: 'Client',
    shopShippingAddress: 'Adresse de livraison',
    shopGeneratingInvoice: 'Génération de la facture...',
    shopSendingToEmail: 'Envoi à votre e-mail',
    shopOrderDetails: 'Détails de la commande',
    shopCustomization: 'Personnalisation',
    shopSendingInvoiceToEmail: 'Envoi de la facture à votre e-mail...',
    shopInvoiceSentTo: 'Facture envoyée à',
    shopPreparingToSendInvoice: 'Préparation de l\'envoi de la facture...',
    shopDone: 'Terminé',
    
    // Application Page Remaining
    welcomeDropZone: 'Bienvenue dans ta',
    dropZoneExclamation: 'Drop Zone !',
    createYourSpace: 'Crée ton espace, un endroit où les idées prennent forme et deviennent réalité.',
    addProfilePhotoAndVisuals: 'Ajoute ta photo de profil et des visuels',
    clickUploadDragDrop: 'Clique pour téléverser ou glisse-dépose ta photo de profil et tes images.',
    suggestVisualsDropZone: 'Propose des visuels qui pourraient illustrer ta drop zone. Ces fichiers ne seront pas publiés automatiquement, mais ils nous aideront à personnaliser ta page.',
    selectProfileFromAdded: 'Sélectionne la photo de profil que tu souhaites utiliser parmi les images que tu as ajoutées. Choisis un visuel clair et représentatif (logo, portrait ou identité visuelle).',
    acceptedFormatsPhoto: 'Formats acceptés: PNG, JPEG, JPG, WebP',
    validImageUploaded: 'Image valide ({size}MB)',
    clickHereUpload: 'Clique ici pour télécharger',
    writeVision: 'Rédige ta vision',
    explainWhatShare: 'Explique ce que tu souhaites partager ou développer avec ta communauté.',
    highlightValues: 'Mets en avant tes valeurs, tes objectifs ou l\'ambiance que tu veux créer.',
    writeVisionHere: 'Écris ta vision ici...',
    introduceYourself: 'Présente-toi',
    talkAboutContent: 'Parle de ton contenu, de tes passions ou de ton univers.',
    fewLinesEnough: 'Quelques lignes suffisent pour donner envie de découvrir ton monde.',
    writeIntroHere: 'Écris ta présentation ici...',
    showcaseContent: 'Mets en avant tes contenus (facultatif)',
    addOneMoreVideos: 'Ajoute une ou plusieurs vidéos (présentation, best-of, moments forts) pour engager ton public dès la première visite.',
    addLink: 'Ajouter un lien',
    removeThisLink: 'Supprimer ce lien',
    applicationSubmittedSuccess: 'Candidature soumise avec succès ! Votre page sera bientôt disponible.',
    errorDuringSubmission: 'Une erreur est survenue lors de la soumission',
    errorOccurred: 'Une erreur est survenue. Veuillez réessayer.',
    
    // Final Application Form Elements
    creatorProjectName: 'Nom du créateur ou de ton projet',
    creatorNamePlaceholder: 'e.g., MyCreatorName or MyProjectName',
    nameWillIdentifyPage: 'Ce nom sera utilisé pour identifier votre page',
    publicationSubjectVerification: 'Publication soumise à vérification',
    whenReadyClickPublish: 'Quand tout est prêt, clique sur',
    publishMyDropZone: 'Publier ma Drop Zone',
    pageVerifiedByTeam: 'Chaque page est vérifiée par notre équipe avant d\'être mise en ligne afin de garantir une expérience de qualité. La mise en ligne n\'est donc',
    notInstantaneous: 'pas instantanée',
    publishingInProgress: 'Publication en cours...',
    noStressModifyLater: 'Pas de stress, tu pourras tout modifier plus tard.',
    
    // Streamers Page
    voteForThem: 'A toi de voter !',
    discoverCreationsAndVote: 'Découvre les créations proposées et vote pour celles que tu veux voir produites.',
    categories: 'Catégories',
    tShirts: 'T-shirts',
    allProducts: 'Tous les produits',
    mugs: 'Mugs',
    accessories: 'Accessoires',
    caps: 'Casquettes',
    areYouCreative: 'Tu Es créatif ?',
    participateInCommunity: 'Participe à la communauté',
    proposeYourDesigns: 'Propose tes designs',
    earnCommissions: 'Gagne des commissions',
    accessDropZone: 'Accéder à la Drop Zone',
    hallOfFame: 'Hall of Fame',
    seeLeaderboard: 'Voir le classement',
    aboutSection: 'À Propos',
    youtubeShorts: 'Youtube SHORTS',
    seeAllVideos: 'Voir toutes les vidéos',
    areYouCreator: 'Tu es',
    participateInCommunityAndEarn: 'Fais participer ta communauté et transforme vos idées en produits.',
    welcomeToMyPage: 'Bienvenue sur ma page !',
    
    // Buttons and Actions (New keys only)
    submitCreation: 'Soumettre une création',
    voteForDesigns: 'Voter pour des designs',
    seeAllCreations: 'Voir toutes les créations',
    seeAllArchive: 'Voir toutes les archives',
    submitMyCreation: 'Soumettre ma création',
    seeMoreVideos: 'Voir plus de vidéos',
    
    // Video section
    video: 'Vidéo',
    loadingVideos: 'Chargement des vidéos...',
    clickToWatch: 'Cliquez pour regarder',
    
    // These FAQ keys already exist elsewhere in the file
    
    // Creative Process
    submitYourCreation: 'Soumets ta création',
    proposeOriginalDesign: 'Propose un design original : illustration, slogan, artwork… laisse parler ton imagination.',
    signContract: 'Signe le contrat',
    ifDesignSelected: 'Si ton design est retenu, 10 % des ventes te reviennent automatiquement.',
    
    // Creator Features
    communityCreativity: 'Créativité communautaire',
    passiveRevenue: 'Revenus passifs',
    increasedVisibility: 'Visibilité accrue',
    
    // Loading States
    loadingProfile: 'Chargement du profil...',
    
    // Creative Process Step 3
    crossFingers: 'Croise les doigts',
    mostVotedSelected: 'Les créations qui obtiennent le plus de votes seront sélectionnées pour la production.',
    top5DesignsUsed: 'Si ton design fait partie des 5 ayant obtenu le plus de vote, il sera utilisé sur les objets du premier drop.',
    
    from: 'De',
    for: 'pour',
    
    // UserDashboard
    myDashboard: 'Mon Dashboard',
    myUploads: 'Mes uploads',
    myVotes: 'Mes votes',
    navigation: 'NAVIGATION',
    myDesigns: 'Mes Designs',
    designsUploaded: 'Designs uploadés',
    designsVoted: 'Designs votés',
    averageVotes: 'Votes moyens',
    newDesign: 'Nouveau Design',
    by: 'par',
    votesTotal: 'votes total',
    approved: 'approuvé',
    pending: 'en attente',
    rejected: 'rejeté',
    deleted: 'supprimé',
    review: 'révision',
    unknown: 'inconnu',
    noUploadYet: 'Aucun upload encore',
    deleteDesign: 'Supprimer le design',
    areYouSure: 'Êtes-vous sûr de vouloir supprimer',
    thisActionIrreversible: 'Cette action est irréversible.',
    deleting: 'Suppression...',
    successfullyDeleted: 'Supprimé avec succès.',
    failedToDelete: 'Échec de la suppression',
    reasonForRejection: 'Raison du rejet:',
    myChallenges: 'Mes Challenges',
    challengesCreated: 'Challenges créés',
    noChallenge: 'Aucun challenge créé',
    createdOn: 'Créé le',
    expiresOn: 'Expire le',
    active: 'Actif',
    ended: 'Terminé',
    participants: 'Participants:',
    noVoteYet: 'Aucun vote effectué',
    discoverDesigns: 'Découvrir les designs',
    voted: 'Voté',
    status: 'Statut:',
    errorDeletingTryAgain: 'Erreur lors de la suppression. Veuillez réessayer.'
  }
};

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  // Initialize language state
  const [currentLanguage, setCurrentLanguage] = useState('en');
  const [isLanguageLoaded, setIsLanguageLoaded] = useState(false);

  // Load language from localStorage on mount to prevent blink
  useEffect(() => {
    const loadLanguage = () => {
      if (typeof window !== 'undefined') {
        const savedLanguage = localStorage.getItem('preferred-language');
        if (savedLanguage && translations[savedLanguage]) {
          setCurrentLanguage(savedLanguage);
        }
      }
      setIsLanguageLoaded(true);
    };

    loadLanguage();
  }, []);

  // Save language to localStorage when it changes (after initial load)
  useEffect(() => {
    if (isLanguageLoaded) {
      localStorage.setItem('preferred-language', currentLanguage);
    }
  }, [currentLanguage, isLanguageLoaded]);

  // Don't render children until language is loaded to prevent blink
  if (!isLanguageLoaded) {
    return (
      <div className="min-h-screen bg-gray-900 flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-white"></div>
      </div>
    );
  }

  const changeLanguage = (languageCode) => {
    if (translations[languageCode]) {
      setCurrentLanguage(languageCode);
    }
  };

  const t = (key, vars) => {
    let s = translations[currentLanguage]?.[key] ?? translations['en']?.[key] ?? key;
    if (vars && typeof s === 'string') {
      for (const [k, v] of Object.entries(vars)) {
        s = s.split(`{${k}}`).join(String(v));
      }
    }
    return s;
  };

  const value = {
    currentLanguage,
    changeLanguage,
    t,
    translations: translations[currentLanguage]
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageContext;
